{
  "imageCropper": {
    "title": "Crop profile picture",
    "hint": "Drag to reposition",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "common": {
    "upload": "Import",
    "search": "Search",
    "searchInput": {
      "placeholder": "Search for a resource"
    },
    "planzoneKnowledge": "Help Center",
    "filterMenu": {
      "search": "Search",
      "erase": "Clear filters",
      "zones": {
        "title": "All zones"
      },
      "projects": {
        "title": "Projects"
      },
      "projectPortfolios": {
        "title": "Portfolios"
      },
      "projectsElementsTags": {
        "title": "Tags"
      },
      "projectsTags": {
        "title": "Projects tags"
      },
      "projectStatuses": {
        "title": "Project statuses"
      },
      "resourceTags": {
        "title": "Resource tags"
      },
      "resources": {
        "title": "Users",
        "everyone": "Everyone",
        "me": "me"
      },
      "groups": {
        "title": "Groups"
      },
      "roles": {
        "title": "Roles"
      },
      "organizationalUnits": {
        "title": "Organizational units"
      }
    },
    "resourceAllocationForm": {
      "searchPlaceholder": "Search",
      "allResources": "Everyone",
      "me": " (me)",
      "resources": "Users",
      "groups": "Groups",
      "resourceTags": "Resource tags"
    },
    "scenePlaceholder": {
      "title": "This page is not available",
      "message": "You do not have access to this link or the link is invalid",
      "goBack": "Go back"
    },
    "constraintsPopup": {
      "remainingConstrainedElementsTitle": "Is constrained by",
      "constrainedElementsTitle": "Constrained",
      "title": "Pending validation of the following elements",
      "seeConstraint": "See more"
    },
    "removedCommentAuthor": "Ressource supprimée",
    "secondaryCriteriaTemplatePlaceholder": {
      "title": "You have not yet configured your custom fields",
      "message": "Select the type of custom fields you want to add below"
    }
  },
  "secondaryCriteriaForm": {
    "linkForm": {
      "text": "Your text",
      "link": "Your link",
      "submit": "Submit"
    }
  },
  "units": {
    "time": {
      "day": {
        "symbol": {
          "singular": "d",
          "plural": "d"
        },
        "text": {
          "singular": "day",
          "plural": "days"
        }
      },
      "hour": {
        "symbol": {
          "singular": "h",
          "plural": "h"
        },
        "text": {
          "singular": "hour",
          "plural": "hours"
        }
      }
    },
    "currency": {
      "euro": {
        "symbol": {
          "singular": "€",
          "plural": "€"
        },
        "text": {
          "singular": "euro",
          "plural": "euros"
        }
      }
    }
  },
  "exports": {
    "projectBudget": {
      "project": "Project",
      "createdAt": "on",
      "createdBy": "created by",
      "projectBudgetSynthesis": {
        "title": "Budget",
        "plannedBudget": {
          "title": "Planned",
          "headers": {
            "planned": "Planned",
            "dateMonitoring": "Date Monitoring",
            "total": "Total",
            "workload": "Workload"
          },
          "real": "Committed",
          "acquired": "Acquired",
          "planned": "Planned",
          "budgetAllocated": "Allocated Budget",
          "allocated": "Allocated",
          "past": "Past",
          "remaining": "Remaining",
          "resource": "Resource",
          "expense": "Expense"
        },
        "workload": {
          "title": "Workload"
        },
        "expensesBreakdownByExpenseType": {
          "title": "Cost Breakdown by Expense Type"
        },
        "costsBreakdownByResourceType": {
          "title": "Cost Breakdown by Resource Type",
          "costs": "Costs",
          "external": "External",
          "internal": "Internal",
          "material": "Material"
        },
        "expenses": {
          "title": "Expense List",
          "create": "Expense",
          "orderNumber": "Order No.",
          "name": "Label",
          "expenseType": "Type",
          "quantity": "Qty",
          "unitAmount": "Unit Amount",
          "totalAmount": "Total Amount",
          "plannedDate": "Planned",
          "actualDate": "Real",
          "attachments": "Attachment(s)",
          "attachmentsAdd": "Add"
        }
      }
    },
    "wbs": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "at",
      "createdBy": "by",
      "columnNames": {
        "type": "Type",
        "name": "Name",
        "startDate": "Start date",
        "endDate": "End date",
        "duration": "Duration (days)",
        "allocatedTime": "Allocated (hours)",
        "allocations": "Assigned",
        "progress": "% done",
        "description": "Description",
        "statuses": "Statuses",
        "creationDate": "Creation date",
        "completionDate": "Completion date",
        "tags": "Tags"
      }
    },
    "resourceProjectAllocationReport": {
      "userName": "User Name",
      "userEmail": "User Email",
      "roleInProject": "Role In Project",
      "userStatus": "User Status",
      "projectName": "Project Name",
      "projectStatus": "Project Status",
      "projectZone": "Project Zone",
      "projectStartDate": "Project Start Date",
      "projectEndDate": "Project End Date",
      "year": "Year",
      "month": "Month",
      "allocatedTime": "Allocated Time",
      "spentTime": "Spent Time",
      "maxCompletionDate": "Max Completion Date"
    },
    "customCpamReport": {
      "month": "Month",
      "openVersions": "Open versions count",
      "mepVersions": "MEP versions count",
      "documentationUpToDate": "Documentation up to date",
      "delayActiveProjects": "% Delay on active projects",
      "delayClosedProjects": "% Delay on closed projects"
    },
    "projectReports": {
      "planzone": "Planzone",
      "zone": "Zone",
      "author": "Author",
      "name": "Name",
      "submissionDate": "Submission date"
    },
    "resourcesReport": {
      "worksheetName": "Planzone Resources",
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "Created At",
      "createdBy": "Created By",
      "type": "Type",
      "name": "Name",
      "deactivated": "Deactivated",
      "address": "Address",
      "role": "Role",
      "function": "Function in the organization",
      "description": "Description",
      "group": "Group",
      "tags": "Tags"
    },
    "timeSheetsReport": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "at",
      "createdBy": "by",
      "startDate": "from",
      "endDate": "to",
      "project": "Project",
      "name": "Resource name",
      "deactivated": "Deactivated",
      "function": "Function in the organization",
      "language": "en-EN",
      "total": "Total",
      "allocatedHours": "Allocated hours",
      "reportTypeView": {
        "monthly": "Monthly",
        "weekly": "Weekly",
        "daily": "Daily"
      },
      "status": {
        "deactivated": "deactivated",
        "activated": "active"
      }
    },
    "ganttReport": {
      "planzone": "Planzone",
      "createdAt": "at",
      "gantt": "Gantt from ",
      "endDateGantt": "to",
      "type": "Type",
      "name": "Name",
      "startDate": "Start date",
      "endDate": "End date",
      "progress": "% done",
      "language": "en-EN",
      "week": "W",
      "allocatedTime": "Allocated (hours)",
      "allocations": "Allocations",
      "views": {
        "weekly": "Weekly view",
        "daily": "Daily view",
        "monthly": "Monthly view",
        "yearly": "Yearly view"
      },
      "monthsName": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December"
      },
      "ganttType": {
        "complete": "Detailed",
        "simple": "Simple"
      }
    },
    "resourceUsageReport": {
      "planzone": "Planzone",
      "createdAt": "at",
      "startReport": "from ",
      "endDateReport": "to",
      "resource": "Resource"
    },
    "resourceAllocatedTimeReport": {
      "planzone": "Planzone",
      "createdAt": "at",
      "startReport": "from ",
      "endDateReport": "to",
      "resource": "Resource"
    },
    "taskBudgetReport": {
      "planzone": "Planzone",
      "createdBy": "Exported by",
      "createdAt": "on",
      "startDate": "Period from",
      "endDate": "to",
      "fromOrigin": "Since inception",
      "element": "Activity / Task",
      "allocated": "Allocated",
      "spent": "Spent",
      "remaining": "Remaining",
      "total": "Grand total",
      "emptySheet": "No project"
    },
    "timeSheetsByTaskReport": {
      "planzone": "Planzone",
      "zone": "Zone",
      "createdAt": "at",
      "createdBy": "by",
      "startDate": "from",
      "endDate": "to",
      "project": "Project",
      "name": "Resource name",
      "deactivated": "Deactivated",
      "function": "Function in the organization",
      "language": "en-EN",
      "dateFormats": "MM/dd/yyyy",
      "total": "Total",
      "task": "Tasks",
      "lastDaySaved": "Last day saved",
      "lastDayOfRecording": "Last day of recording",
      "allocatedHours": "Allocated hours",
      "reportTypeView": {
        "monthly": "Monthly",
        "weekly": "Weekly",
        "daily": "Daily"
      },
      "status": {
        "deactivated": "deactivated",
        "activated": "active"
      },
      "tags": "tags"
    },
    "zonesProjectReport": {
      "planzone": "Planzone",
      "createdAt": "Created At",
      "createdBy": "Created By",
      "name": "Name",
      "zoneHeader": {
        "zone": "Portfolio",
        "weather": "Weather",
        "avgScore": "Moy. score strat.",
        "averageDone": "MOY Done",
        "averageDelayed": "MOY Delayed",
        "averageOpend": "MOY Opend",
        "allocatedTime": "Allocated",
        "spentTime": "Spent",
        "remainingWork": "Remaining",
        "plannedBudget": "Planned",
        "realCosts": "Real costs",
        "acquiredValue": "Acquired val."
      },
      "projectHeader": {
        "projectName": "Project name",
        "startDate": "Start date",
        "endDate": "End date",
        "description": "Description",
        "status": "Status",
        "weather": "Weather",
        "avgScore": "Score Strat",
        "activityMonitoring": {
          "title": "Activity monitoring",
          "done": "Done",
          "delayed": "Delayed",
          "opened": "Opened"
        },
        "workload": {
          "title": "Work",
          "allocatedTime": "Allocated",
          "spentTime": "Spent",
          "remainingWork": "Remaining",
          "remainingWorkShort": "TbD"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planned",
          "realCosts": "Real costs",
          "acquiredValue": "Acquired val."
        }
      },
      "projectStatuses": {
        "pz_closed": "Closed",
        "pz_waiting": "On hold",
        "pz_candidate": "Requested",
        "pz_open": "Open"
      },
      "graphsSheet": "Graphs",
      "graphsTitle": "Projects by status"
    },
    "projectPortfoliosReport": {
      "planzone": "Planzone",
      "createdAt": "Created At",
      "createdBy": "Created By",
      "name": "Name",
      "zoneHeader": {
        "zone": "Zone",
        "weather": "Weather",
        "avgScore": "Strat. score",
        "averageDone": "MOY Done",
        "averageDelayed": "MOY Delayed",
        "averageOpend": "MOY Opend",
        "allocatedTime": "Allocated",
        "spentTime": "Spent",
        "remainingWork": "Remaining",
        "plannedBudget": "Planned",
        "realCosts": "Real costs",
        "acquiredValue": "Acquired val."
      },
      "projectHeader": {
        "projectName": "Project name",
        "startDate": "Start date",
        "endDate": "End date",
        "description": "Description",
        "status": "Status",
        "weather": "Weather",
        "avgScore": "Score Strat",
        "activityMonitoring": {
          "title": "Activity monitoring",
          "done": "Done",
          "delayed": "Delayed",
          "opened": "Opened"
        },
        "workload": {
          "title": "Work",
          "allocatedTime": "Allocated",
          "spentTime": "Spent",
          "remainingWork": "Remaining",
          "remainingWorkShort": "TbD"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planned",
          "realCosts": "Real costs",
          "acquiredValue": "Acquired val."
        }
      },
      "projectStatuses": {
        "pz_closed": "Closed",
        "pz_waiting": "On hold",
        "pz_candidate": "Requested",
        "pz_open": "Open"
      }
    }
  },
  "taskStatuses": {
    "pr_done": "Done",
    "pr_in_progress": "In progress",
    "pr_todo": "To do"
  },
  "search": {
    "title": "Recent projects",
    "placeholder": "Search"
  },
  "projectStatuses": {
    "pz_closed": "Closed",
    "pz_waiting": "On hold",
    "pz_candidate": "Requested",
    "pz_open": "Open",
    "description": {
      "pz_closed": "The closed project is kept for archive.",
      "pz_waiting": "The project is interrupted and can no longer be edited.",
      "pz_candidate": "The project requires validation before it can go into the open state.",
      "pz_open": "The project is in progress. This is editable."
    }
  },
  "roles": {
    "pz_admin": "Administrator",
    "pz_under_admin": "Project creator",
    "pz_user": "User",
    "pz_visitor": "Visitor",
    "pr_visitor": "Observer",
    "pr_manager": "Project manager",
    "pr_worker": "Collaborator",
    "description": {
      "pz_admin": "Manages global settings, can create, view, edit, and delete all projects in Planzone.",
      "pz_under_admin": "Can create and set up projects in Zones. Can only see their own projects and those to which they are assigned.",
      "pz_user": "Accesses the areas and projects to which they are assigned. The possible actions on a project will depend on the assigned project role.",
      "pz_visitor": "Accesses zones and projects to which they are assigned in read-only mode. Accesses document management and discussion features.",
      "pr_visitor": "Accesses the different views of the project in read-only mode.",
      "pr_manager": "Plans, allocates resources on tasks and edits project details.",
      "pr_worker": "Accesses the different views of the project and carries out the assigned tasks."
    }
  },
  "milestoneStatuses": {
    "TODO": "To do",
    "DONE": "Done"
  },
  "projectsList": {
    "label": "Label",
    "taskStatus": "Project status",
    "projectChief": "Project chief",
    "startDate": "Start date",
    "endDate": "End date",
    "weather": "Whether",
    "reports": "Reports"
  },
  "notifications": {
    "at": "at",
    "placeholder": "You have no notification",
    "mentionInComment": {
      "commented": "commented",
      "seeMore": "See more"
    },
    "replyToComment": {
      "replied": "replied to your comment",
      "seeMore": "See more"
    },
    "addedToTask": {
      "assigned": "has assigned you to the task"
    },
    "addedToEvent": {
      "assigned": "invited you to participate in the event"
    },
    "addedToProject": {
      "assigned": "has assigned you to the project"
    },
    "delayedTask": {
      "task": "The task",
      "is": "is",
      "delayed": "delayed"
    },
    "exportBiFinished": {
      "title": "BI export",
      "status": "Your BI export is",
      "seeExport": "See export"
    },
    "seeAll": "See all notifications"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "projects": "Projects",
    "tasks": "Tasks",
    "contacts": "Contacts"
  },
  "logIn": {
    "title": "Log in",
    "subTitle": "I have a Planzone or I have been invited to a Planzone",
    "emailLabel": "Your email address",
    "emailPlaceholder": "Email of your company",
    "passwordLabel": "Your password",
    "passwordPlaceholder": "Enter your password",
    "authenticate": "Log in"
  },
  "registration": {
    "title": "Start your 30-day trial for free",
    "subTitle": "With just a few clicks, no credit card required",
    "lastNameTitle": "Last name",
    "lastNamePlaceholder": "Last name",
    "firstNameTitle": "First name",
    "firstNamePlaceholder": "First name",
    "emailTitle": "Professional email",
    "emailPlaceholder": "Valid email address",
    "phoneNumberTitle": "Phone number",
    "phoneNumberPlaceholder": "Phone number",
    "teamTitle": "Size of your team",
    "teamPlaceholder": "Please select one option",
    "projectDescriptionTitle": "A few words about your project",
    "projectDescriptionPlaceholder": "Description",
    "consent": "By clicking on the button below, you agree to accept our",
    "legalMentions": "Legal mentions",
    "submit": "Get started for free",
    "plans": {
      "basic": "Basic",
      "team": "Team",
      "business": "Business",
      "enterprise": "Enterprise",
      "enterprisePremium": "Enterprise+"
    }
  },
  "fillAccount": {
    "title": "Create your account",
    "message": "Hello {{-fullName}}, to confirm your registration, fill in your password.",
    "password": {
      "label": "Password*",
      "placeholder": "12 characters, at least 1 uppercase and 1 special character"
    },
    "submit": "Join Planzone",
    "redirection": {
      "title": "You have already confirmed your registration",
      "message": "You can click on the link below to log in",
      "redirect": "Login"
    },
    "errors": {
      "tooShort": "The password must be at least 12 characters long.",
      "specialCharsOrNum": "The password must contain at least one number or special character.",
      "upper": "The password must contain at least one capital letter.",
      "mismatchedConfirmation": "The confirmation of your password does not match your password."
    }
  },
  "accountCreationConfirmation": {
    "usernameTitle": "Account Name",
    "usernamePlaceholder": "Name",
    "passwordTitle": "Password",
    "passwordPlaceholder": "Password",
    "passwordConfirmationTitle": "Confirmation",
    "passwordConfirmationPlaceholder": "Confirmation",
    "companyTitle": "Name of your company",
    "companyPlaceholder": "Company",
    "titleTitle": "Your position",
    "titlePlaceholder": "Please select",
    "addressTitle": "Your address",
    "addressPlaceholder": "Address",
    "planzoneNameTitle": "Planzone name",
    "planzoneNamePlaceholder": "Planzone name",
    "planzoneDomainTitle": "Url of your Planzone",
    "planzoneDomainPlaceholder": "Url of your Planzone",
    "submit": {
      "createPlanzone": "I create my Planzone",
      "createAccount": "I create my account"
    },
    "accountTitle": "Complete your registration",
    "submitAccountForm": "Step 2",
    "planzoneTitle": "Name your Planzone",
    "goBack": "Go back"
  },
  "wizardForm": {
    "title": "Step",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit"
  },
  "jobTitles": {
    "director": "Management / Senior Manager",
    "manager": "Manager",
    "contributor": "Employee",
    "intern": "Student / Intern",
    "other": "Other"
  },
  "taskForm": {
    "name": "Task name",
    "rename": "Rename",
    "description": "Task description",
    "characters": "characters"
  },
  "eventForm": {
    "name": "Event name",
    "rename": "Rename",
    "description": "Event description",
    "characters": "characters"
  },
  "milestoneForm": {
    "name": "Milestone name",
    "rename": "Rename",
    "description": "Milestone description",
    "characters": "characters"
  },
  "listForm": {
    "name": "List name",
    "rename": "Rename",
    "description": "List description",
    "characters": "characters"
  },
  "tagForm": {
    "placeholder": "New tag",
    "noTags": "No tags",
    "submit": "Add"
  },
  "landing": {
    "title": "Welcome",
    "message": "Take charge of your projects from your mobile !",
    "subTitle": "📐📱📝",
    "start": "Start",
    "register": "I do not have an account. Register now"
  },
  "layout": {
    "navigation": {
      "synthesis": "My space",
      "members": "Members",
      "costProfiles": "Profiles",
      "capacity": "Capacity",
      "workload": "Planned workload",
      "occupancy": "Occupation ratio",
      "management": "Management",
      "finances": "Finances",
      "resources": "Resources",
      "obs": "Org chart",
      "utilities": "Customization",
      "portfolios": "Portfolios",
      "calendar": "Calendar",
      "documents": "Documents",
      "exportReports": "Export / Reports",
      "assistant": "AI Assistant",
      "strategy": "Strategy",
      "strategicAxes": "Strategic axes"
    },
    "notifications": {
      "noProjectsFound": "No project"
    }
  },
  "membersList": {
    "user": "User",
    "title": "Job title",
    "planzoneTeams": "Global groups",
    "projectTeams": "Local groups",
    "name": "Name",
    "tags": "Tags",
    "role": "Role in project",
    "groupLength": "members",
    "groupPlaceholder": "You don't have any teams. Add a team.",
    "contextualMenu": {
      "toggle": "Plus",
      "edit": "Edit",
      "remove": "Remove",
      "delete": "Delete",
      "disable": "Disable",
      "activate": "Activate",
      "transfer": "Transfer allocations"
    }
  },
  "personalSynthesis": {
    "welcome": "Hello {{-name}} \uD83D\uDC4B\uD83C\uDFFC",
    "milestonesList": {
      "title": "Next milestones",
      "placeholder": "You don't have any milestones"
    },
    "planning": "Planning",
    "status": {
      "title": "My status",
      "subTitle": "My tasks",
      "doneTasksNumber": "Done",
      "onGoingTasksNumber": "Opened",
      "overDueTasksNumber": "Late"
    },
    "navigation": {
      "synthesis": "My overview",
      "timeSheets": "Time recording"
    },
    "sort": {
      "name": "Name",
      "status": "Status",
      "date": "End date"
    },
    "resourceFilter": "Resource",
    "synthesisOf": "Synthesis of",
    "overDueTasks": "Overdue tasks",
    "doneTasks": "Completed tasks",
    "upComingTasks": "Upcoming and open tasks",
    "blockedTasksToggle": "Blocked tasks",
    "myTasks": "My tasks",
    "done": "done",
    "onGoing": "opened",
    "overDue": "late"
  },
  "taskRetrieval": {
    "allocations": {
      "resource": "Assigned",
      "allocatedHours": "Allocated",
      "spentHours": "Spent",
      "progress": "Completion",
      "placeholder": "Select a collaborator"
    },
    "constraint": "The element is constrained and cannot be started",
    "startDate": "Start",
    "endDate": "End",
    "completionDate": "Real",
    "description": "Description",
    "secondaryCriteria": "Custom fields",
    "advancement": "Advancement",
    "status": "Status",
    "type": "Task",
    "notifications": {
      "noTasksFound": "No tasks match your search"
    },
    "expenditureType": {
      "label": "Budget Nature",
      "none": "None",
      "capex": "Capex",
      "opex": "Opex"
    },
    "tags": "Tags"
  },
  "retrieveEvent": {
    "title": "Event details",
    "startTime": "Start",
    "endTime": "End",
    "description": "Description",
    "participants": "Participants",
    "tags": "Tags",
    "secondaryCriteria": "Custom fields",
    "copyUrl": "Copy link",
    "edit": "Edit",
    "move": "Move",
    "remove": "Remove"
  },
  "milestoneRetrieval": {
    "allocations": {
      "resource": "Assigned to the task",
      "allocatedHours": "Hours allocated",
      "progress": "Progress on the task"
    },
    "constraint": "The element is constrained and cannot be started",
    "startDate": "Start",
    "endDate": "End",
    "completionDate": "Real",
    "secondaryCriteria": "Custom fields",
    "description": "Description",
    "advancement": "Advancement of the task",
    "copyUrl": "Copy link",
    "move": "Move",
    "remove": "Delete"
  },
  "synthesis": {
    "emptyTasks": "No tasks",
    "onGoingTasksTitle": "Ongoing tasks",
    "overDueTasksTitle": "Overdue tasks",
    "newTasksTitle": "New tasks"
  },
  "contacts": {
    "administratorsTitle": "Administrators",
    "membersTitle": "Members",
    "visitorsTitle": "Visitors"
  },
  "planning": {
    "today": "Today",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "project": {
    "navigation": {
      "dashboard": "Dashboard",
      "tasks": "Tasks",
      "team": "Team"
    },
    "team": {
      "managers": "Project managers",
      "collaborators": "Collaborators",
      "visitors": "Visitors"
    },
    "projectEvolution": {
      "title": "Project evolution",
      "projectOverDueTitle": "The project is",
      "projectOverDueDaysNbr": "days late",
      "projectAdvanceTitle": "The project is",
      "projectAdvanceDaysNbr": "days of advance",
      "message": "The project is on time"
    },
    "milestonesList": {
      "title": "Next milestones"
    },
    "projectProgress": {
      "title": "Project progress",
      "milestonesCount": "{{ count }} milestones done",
      "allocatedHours": "{{ hours }} allocated hours",
      "projectWithHours": "{{ hours }} with hours",
      "projectWithoutHours": "{{ hours }} without hours"
    },
    "statuses": {
      "creation": {
        "addStatus": "Add a status",
        "submit": "Save"
      }
    }
  },
  "projectDetails": {
    "title": "Project details {{- name }}",
    "nameTitle": "Project name",
    "namePlaceholder": "Project name",
    "descriptionTitle": "Description",
    "startDateTitle": "Start date",
    "endDateTitle": "End date",
    "projectStatus": "Project status",
    "redirectProject": "go to project",
    "projectPortfoliosList": "Portfolio(s)",
    "tagsList": "Tag(s)",
    "secondaryCriteria": "Custom fields",
    "budget": {
      "allocated": "Allocated Budget",
      "planned": "Planned Budget",
      "tracking": "Actual Tracking",
      "margins": "Margins",
      "allocatedResourcesBudget": "Resources",
      "allocatedExpensesBudget": "Expenses",
      "allocatedBudget": "Total",
      "costs": "Costs"
    },
    "statuses": {
      "title": "Task status settings",
      "message": "Add or remove statuses, assign completion percentages"
    },
    "toolsConfiguration": {
      "title": "Views",
      "label": "Enable all",
      "parameters": {
        "synthesis": {
          "name": "Synthesis",
          "description": "Summary of project performance"
        },
        "listsList": {
          "name": "List",
          "description": "List of all project items"
        },
        "gantt": {
          "name": "Gantt",
          "description": "Represents all project elements on a time axis"
        },
        "kanban": {
          "name": "Kanban",
          "description": "List your tasks according to their status"
        },
        "timeSheets": {
          "name": "Time recording",
          "description": "Shows the time spent and the remaining resources to do"
        },
        "discussions": {
          "name": "Discussions",
          "description": "All discussions between you and your colleagues"
        },
        "documents": {
          "name": "Documents",
          "description": "List and grid of all documents related to this project"
        },
        "budget": {
          "name": "Budget",
          "description": "Dashboard summarizing all budgetary aspects of the project"
        },
        "calendar": {
          "name": "Calendar",
          "description": "View all project events, tasks, and milestones on a calendar"
        },
        "reports": {
          "name": "Reports / Exports",
          "description": "Generate project reports and exports, like the daily planning"
        }
      }
    },
    "resources": {
      "title": "Resources",
      "humanResources": "Members",
      "virtualResources": "Virtual members",
      "materialResources": "Material resources"
    }
  },
  "projects": {
    "allProjects": "Your projects",
    "tasksListsNbr": "{{ tasksNbr }} tasks lists"
  },
  "profile": {
    "menu": {
      "preferences": "Personal settings",
      "planzoneParameters": "Planzone settings",
      "logOut": "Log out"
    }
  },
  "wbs": {
    "columnNames": {
      "statuses": "Statuses",
      "tags": "Tags",
      "allocations": "Assignees",
      "allocated": "Allocated",
      "spent": "Spent",
      "startDate": "Start",
      "endDate": "End",
      "completionDate": "Actual"
    }
  },
  "projectSection": {
    "projectName": "Project name",
    "startDate": "Start",
    "endDate": "End",
    "columnNames": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "status": "Status",
      "weather": "weather",
      "strategicScore": "Strat. score",
      "activityMonitoring": "Activity monitoring",
      "activityMonitoring_done": "Done",
      "activityMonitoring_delayed": "Delayed",
      "activityMonitoring_opened": "Opened",
      "workload": "Work",
      "workload_allocatedTime": "Allocated",
      "workload_spentTime": "Spent",
      "workload_remainingWork": "TbD",
      "budget": "Budget",
      "budget_plannedBudget": "Planned",
      "budget_realCosts": "Real costs",
      "budget_acquiredValue": "Acquired",
      "budget_allocatedBudget": "Allocated",
      "budget_plannedMargin": "Planned Margin",
      "budget_realMargin": "Real Margin",
      "projectManagers": "Managers",
      "portfolios": "portfolios"
    },
    "contextualMenu": {
      "projectDetails": "Project details",
      "projectStatus": "Handle status",
      "createProjectModel": "Create a template",
      "strategicImpact": "Strategical impact",
      "move": "Move",
      "duplicate": "Duplicate",
      "remove": "Remove"
    }
  },
  "projectListingConfiguration": {
    "title": "Project listing configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "status": "Status",
      "weather": "weather",
      "portfolios": "Portfolios",
      "strategicScore": "Strategic score",
      "activityMonitoring": "Activity monitoring",
      "activityMonitoring_done": "Activity monitoring: Work done",
      "activityMonitoring_delayed": "Activity monitoring: Delayed work",
      "activityMonitoring_opened": "Activity monitoring: Opened work",
      "workload": "Work",
      "workload_allocatedTime": "Work: Allocated time",
      "workload_spentTime": "Work: Spent time",
      "workload_remainingWork": "Work: Remaining work",
      "budget": "Budget",
      "budget_plannedBudget": "Budget: Planned budget",
      "budget_realCosts": "Budget: Real costs",
      "budget_acquiredValue": "Budget: Acquired value",
      "budget_allocatedBudget": "Allocated",
      "budget_plannedMargin": "Planned Margin",
      "budget_realMargin": "Real Margin",
      "tags": "Tags",
      "projectManagers": "Managers",
      "zone": "Zone"
    },
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "resourcesListingConfiguration": {
    "title": "Columns configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "tags": "Tags",
      "role": "Role",
      "invitationStatus": "Invitation status",
      "subordinates": "Manages the times of",
      "organizationalUnit": "Organizational unit"
    },
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "projectMembersListingConfiguration": {
    "title": "Columns configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "tags": "Tags",
      "role": "Role"
    },
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit",
    "localCriteria": "local"
  },
  "projectDetailsConfiguration": {
    "title": "Project details configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "status": "Status",
      "weather": "weather",
      "strategicScore": "Strategic score",
      "activityMonitoring": "Activity monitoring",
      "activityMonitoring_done": "Activity monitoring: Work done",
      "activityMonitoring_delayed": "Activity monitoring: Delayed work",
      "activityMonitoring_opened": "Activity monitoring: Opened work",
      "workload": "Work",
      "workload_allocatedTime": "Work: Allocated time",
      "workload_spentTime": "Work: Spent time",
      "workload_remainingWork": "Work: Remaining work",
      "budget": "Budget",
      "budget_plannedBudget": "Budget: Planned budget",
      "budget_realCosts": "Budget: Real costs",
      "budget_acquiredValue": "Budget: Acquired value",
      "budget_allocatedBudget": "Allocated",
      "budget_plannedMargin": "Planned Margin",
      "budget_realMargin": "Real Margin",
      "tags": "Tags",
      "projectManagers": "Managers",
      "zone": "Zone"
    },
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "wbsConfiguration": {
    "title": "List configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "statuses": "Statuses",
      "tags": "Tags",
      "allocations": "Allocations",
      "allocated": "Allocated",
      "spent": "Time spent",
      "startDate": "Start Date",
      "endDate": "End date",
      "completionDate": "Completion"
    },
    "localCriteria": "local",
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "projectElementDetailsConfiguration": {
    "title": "Details configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "statuses": "Statuses",
      "tags": "Tags",
      "allocations": "Allocations",
      "endDate": "End date"
    },
    "localCriteria": "local",
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "resourceDetailsConfiguration": {
    "title": "Resource details configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "constrainElement": {
    "title": {
      "START_START": "Create a start start constraint",
      "END_END": "Create an end end constraint",
      "START_END": "Create a start end constraint",
      "END_START": "Create an end start constraint"
    },
    "dateTypes": {
      "START": "The start",
      "END": "The end"
    },
    "beginsAt": "at",
    "endsAt": "at",
    "of": "Of",
    "startDate": "Start",
    "endDate": "End",
    "cancel": "Cancel",
    "submit": "Create"
  },
  "editConstraint": {
    "title": {
      "START_START": "Edit a start start constraint",
      "END_END": "Edit an end end constraint",
      "START_END": "Edit a start end constraint",
      "END_START": "Edit an end start constraint"
    },
    "dateTypes": {
      "START": "The start",
      "END": "The end"
    },
    "beginsAt": "at",
    "endsAt": "at",
    "of": "Of",
    "startDate": "Start",
    "endDate": "End",
    "remove": "Remove",
    "cancel": "Cancel",
    "submit": "Edit"
  },
  "constraintTypeForm": {
    "constraintTypes": {
      "EXACTLY": "exactly",
      "AT_MOST": "at most",
      "AT_LEAST": "at least"
    },
    "deltas": {
      "days": "day(s)",
      "hours": "hour(s)",
      "before": "before",
      "after": "after"
    },
    "begins": "Begins",
    "ends": "Ends"
  },
  "listsList": {
    "placeholder": {
      "emptyMatch": "No items match your search."
    },
    "contextualMenu": {
      "edit": "Edit",
      "move": "Move",
      "addIn": "Create inside",
      "addAfter": "Create after",
      "duplicate": "Duplicate",
      "remove": "Remove"
    },
    "quickCreation": {
      "createTask": "Name a task",
      "createList": "Name a list",
      "createMilestone": "Name a milestone",
      "createEvent": "Name an event",
      "createUnavailability": "Name an unavailability",
      "task": "Task",
      "list": "List",
      "milestone": "Milestone",
      "event": "Event",
      "unavailability": "Unavailability",
      "submit": "Submit"
    },
    "tags": {
      "placeholder": "New tag",
      "submit": "Add"
    }
  },
  "taskCreation": {
    "title": "Task creation",
    "duplicateTitle": "Duplicate task ",
    "taskCreationForm": {
      "nameTitle": "Name the task",
      "namePlaceholder": "Task name",
      "assignedMembersTitle": "Assign to",
      "startDatePlaceholder": "Start date",
      "endDatePlaceholder": "End date",
      "projectSelectionPlaceholder": "Select a project",
      "inProject": "In the project",

      "isHourAccurate": "Planned down to the minute"
    },
    "submit": "Create",
    "duplicate": "Duplicate",
    "cancel": "Cancel",
    "nameTitle": "Name the task",
    "namePlaceholder": "Give the task a name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Start",
    "startDatePlaceholder": "Select a date",
    "endDateTitle": "End",
    "endDatePlaceholder": "Select a date",
    "allocationsTitle": "Assigned to",
    "statusTitle": "Displayed status",
    "parentListTitle": "Is part of",
    "parentListPlaceholder": "Choose a list",
    "teamMembersList": {
      "title": "Assign a member"
    },
    "allocations": {
      "assignees": "Assignees",
      "allocatedHours": "Allocated hours",
      "placeholder": "Choose one or more participants",
      "hours": "hours"
    }
  },
  "calendarHolidays": {
    "creation": {
      "title": "Create a customized calendar",
      "cancel": "Cancel",
      "submit": "Save",
      "nameTitle": "Calendar Name",
      "namePlaceholder": "Holidays",
      "holidaysTitle": "holidays :",
      "addHoliday": "Add",
      "holidayCreation": {
        "namePlaceholder": "Holiday Name",
        "datePlaceholder": "Choose a date"
      }
    },
    "removal": {
      "title": "Are you sure you want to delete this calendar?",
      "confirmation": "The calendar will be deleted and removed from the planzone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    },
    "edition": {
      "title": "Edit a Custom Calendar",
      "cancel": "Cancel",
      "submit": "Update",
      "nameTitle": "Name of the Calendar",
      "namePlaceholder": "Give the Calendar a name",
      "holidaysTitle": "Holidays",
      "addHoliday": "Add",
      "holidayEdition": {
        "namePlaceholder": "Holiday name",
        "datePlaceholder": "Choose a date"
      }
    }
  },
  "eventCreation": {
    "title": "Event creation",
    "submit": "Create",
    "cancel": "Cancel",
    "nameTitle": "Name the event",
    "namePlaceholder": "Give the event a name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Start",
    "startDatePlaceholder": "Select a date",
    "endDateTitle": "End",
    "endDatePlaceholder": "Select a date",
    "assignedMembersTitle": "Add participants",
    "allocationsTitle": "Assigned to",
    "statusTitle": "Displayed status",
    "parentListTitle": "Is part of",
    "parentListPlaceholder": "Choose a list",
    "projectSelectionPlaceholder": "Select a project",
    "inProject": "In the project",
    "selectAllDay": "All day",
    "teamMembersList": {
      "title": "Assign a member"
    },
    "allocations": {
      "assignees": "Assignees",
      "allocatedHours": "Allocated hours",
      "placeholder": "Choose one or more participants",
      "hours": "hours"
    }
  },
  "taskEdition": {
    "title": "Task edition",
    "taskEditionForm": {
      "nameTitle": "Name the task",
      "namePlaceholder": "Task name",
      "assignedMembersTitle": "Assign to",
      "startDatePlaceholder": "Start date",
      "endDatePlaceholder": "End date",
      "projectSelectionPlaceholder": "Select a project"
    },
    "submit": "Save modification",
    "teamMembersList": {
      "title": "Assign a member"
    }
  },
  "dateTimeQuickSelection": {
    "today": "Today",
    "tomorrow": "Tomorrow",
    "nextWeek": "Next week",
    "nextMonth": "Next month",
    "nextYear": "Next year"
  },
  "dateTimeInput": {
    "projectTimezoneTitle": "Time entry in project timezone ({{timezone}})"
  },
  "error": {
    "title": "An unknown error has occurred",
    "message": "Press the button below to reload this page. If the problem persists contact us on",
    "contactMail": "tickets@planzone.com",
    "retry": "Retry"
  },
  "zones": {
    "allZones": "My zones",
    "name": "Name",
    "seeZone": "See the details of the zone",
    "addZone": "+ zone",
    "allZone": "All",
    "zonesPlaceholder": "No zones yet. Create your first zone to start organizing your projects."
  },
  "zoneRemoval": {
    "title": "Are you sure you want to delete this zone?",
    "message": "The removal of the Planzone",
    "message2": "will result in the deletion of all the projects it contains.",
    "confirm": "Remove",
    "cancel": "Cancel",
    "tasks": "task(s)",
    "noProjectsFound": "No project"
  },
  "constraintRemoval": {
    "title": "Are you sure you want to delete this constraint ?",
    "message": "This constraint will be deleted definitively.",
    "message2": "will result in the deletion of all the projects it contains.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "projectsTransfer": {
    "title": "Destination area",
    "projects": {
      "selectAll": "Select all",
      "title": "Selector of one or more projects to move"
    },
    "message": "Choose an area to transfer these projects to",
    "confirm": "Transfer",
    "cancel": "Cancel",
    "success": {
      "title": "Success",
      "message": "The zone \"{{- srcName }}\" has been successfully transferred to the \"{{- dstName }}\" zone",
      "confirm": "Ok"
    }
  },
  "zone": {
    "projects": "Projects",
    "discussions": "Discussions",
    "tasks": "Tasks",
    "close": "Close details",
    "resources": "Resources",
    "edit": "Edit",
    "remove": "Delete",
    "transfer": "Transfer projects",
    "error": "An error occured",
    "goToZone": "Go to the area"
  },
  "calendarExportLinks": {
    "title": "Calendar Export Links Management",
    "meOnly": "My Items Only",
    "everyone": "All Items"
  },
  "zoneCreation": {
    "nameTitle": "Zone name",
    "namePlaceholder": "Enter a zone name",
    "descriptionTitle": "Zone description",
    "descriptionPlaceholder": "Enter a zone description",
    "colorTitle": "Select your zone's name",
    "title": "Create a new zone",
    "submit": "Create",
    "cancel": "Cancel"
  },
  "startDiscussion": {
    "title": "Create a new discussion thread",
    "subject": "Subject",
    "comment": "Your comment",
    "recipients": "Send by email to",
    "submit": "Create",
    "cancel": "Cancel"
  },
  "folderCreation": {
    "title": "Create a new folder",
    "nameTitle": "Name (required)",
    "namePlaceholder": "Name the folder",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "parentFolderTitle": "Main folder",
    "parentFolderPlaceholder": "Choose the main folder",
    "folderSelection": {
      "root": "Root"
    },
    "submit": "Create",
    "cancel": "Cancel"
  },
  "selectDocuments": {
    "title": "Import Files",
    "folders": "Folders",
    "documents": "Files",
    "uploadDocument": "Upload a document",
    "selectedDocuments": "selected items",
    "selectedDocument": "selected item",
    "resetSelection": "Clear Selection",
    "folderCard": {
      "element": "element",
      "elements": "elements"
    },
    "submit": "Import",
    "cancel": "Cancel"
  },
  "zoneEdition": {
    "title": "Details of the {{- name }} zone",
    "descriptionPlaceholder": "Description",
    "save": "Save",
    "cancel": "Cancel"
  },
  "projectCreation": {
    "zoneSelectionPlaceholder": "Select a zone",
    "projectTypeChoice": {
      "title": "Create a new project",
      "subTitle": "How do you want to create your project ?",
      "project": {
        "title": "From scratch",
        "description": "Create and customize your project from a new base"
      },
      "projectModel": {
        "title": "From a template",
        "description": "Save time with a pre-defined project template"
      }
    },
    "title": "Create a project from scratch",
    "projectModelTitle": "Create a project template",
    "nameTitle": "Project name",
    "namePlaceholder": "Enter a project name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "Enter a project description",
    "cancel": "Cancel",
    "submit": "Create",
    "datesTitle": "Dates",
    "startDateTitle": "Start date",
    "startDatePlaceholder": "Choose a date",
    "endDateTitle": "End date",
    "statusTitle": "Project status",
    "tagsTitle": "Add tags",
    "projectPortfoliosList": "Add portfolios",
    "endDatePlaceholder": "Choose a date",
    "inZone": "In the zone",
    "descriptionMaxCharacter": " / 5000 characters",
    "errorTitleInput": "Please name your project"
  },
  "projectCreationFromModel": {
    "title": "Create a project from a template",
    "subTitle": "Choose a project template",
    "description": "A project template saves you time creating new projects with a similar structure.",
    "use": "Create a project",
    "cancel": "Cancel"
  },
  "projectModelCreationFromProject": {
    "title": "Create a template from a project",
    "submit": "Create",
    "cancel": "Cancel"
  },
  "projectCreationFromProjectModel": {
    "title": "Duplicate a project ",
    "submit": "Create",
    "cancel": "Cancel"
  },
  "projectDuplication": {
    "title": "Duplicate a project",
    "submit": "Create",
    "cancel": "Cancel"
  },
  "assistantPage": {
    "title": "AI Assistant"
  },
  "chatbot": {
    "header": {
      "title": "Planzone Intelligence"
    },
    "sidebar": {
      "title": "History",
      "empty": "No conversations",
      "untitled": "Untitled",
      "newConversation": "New conversation",
      "resetMemory": "Reset memory",
      "delete": "Delete",
      "collapse": "Collapse history",
      "expand": "Expand history"
    },
    "messages": {
      "empty": "Ask a question to start the conversation."
    },
    "input": {
      "placeholder": "Write your message...",
      "send": "Send",
      "cancel": "Cancel"
    },
    "notification": {
      "title": "New reply",
      "body": "The assistant has finished its reply."
    },
    "error": "Something went wrong while generating the response."
  },
  "chatConversationRemoval": {
    "title": "Are you sure you want to delete this conversation?",
    "message": "Deleting the conversation",
    "confirm": "Delete",
    "cancel": "Cancel"
  },
  "searchPage": {
    "title": "Search results",
    "filters": {
      "name": "Search..."
    },
    "types": {
      "anyType": "All results",
      "project": "Projects",
      "task": "Tasks",
      "milestone": "Milestones"
    }
  },
  "unExpectedErrorPage": {
    "title": "Oops… An error has occurred",
    "message": "Our teams were automatically informed and are already working to resolve it.",
    "refresh": "Refresh",
    "sendReport": "Send report"
  },
  "zonePage": {
    "projectDetails": "Details",
    "move": "Move",
    "filterForm": {
      "me": "Me",
      "everyone": "Everyone",
      "filtersTitle": "Filters",
      "open": "Sorted by opened projects",
      "alphabetical": "Sorted alphabetically"
    },
    "menu": {
      "details": "Zone details",
      "remove": "Remove"
    },
    "navigation": {
      "project": "Projects",
      "synthesis": "Synthesis",
      "list": "List",
      "gantt": "Gantt",
      "kanban": "Board",
      "timeSheets": "Time recording",
      "reports": "Reporting",
      "workloads": "Workload",
      "calendar": "Calendar"
    },
    "projects": {
      "title": "Projects in the zone",
      "average": "avr",
      "labels": {
        "projectName": "Project name",
        "dates": "Dates",
        "startDate": "Start",
        "endDate": "End",
        "avgScore": "Strat. score",
        "score": "Strat. score",
        "status": "Status",
        "weather": "Weather",
        "activityMonitoring": {
          "title": "Activity monitoring",
          "done": "Done",
          "delayed": "Delayed",
          "opened": "Opened"
        },
        "workload": {
          "title": "Work",
          "allocatedTime": "Allocated",
          "spentTime": "Spent",
          "remainingWork": "Remaining",
          "remainingWorkShort": "TbD"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planned",
          "realCosts": "Real costs",
          "acquiredValue": "Acquired"
        }
      },
      "filterPlaceholder": "Any projects",
      "createProject": "Project",
      "editZone": "Edit",
      "removeZone": "Remove",
      "sorter": {
        "title": "Sort by :",
        "default": "No sorting",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Start date",
        "endDate": "End date",
        "completionDate": "Completion date",
        "creationDate": "Creation date"
      },
      "filters": {
        "title": "Filter by :",
        "placeholderZone": "All projects",
        "placeholderResource": "Everyone",
        "showProjectsOf": "Show projects of"
      },
      "contextualMenu": {
        "projectDetails": "Project details",
        "projectStatus": "Handle status",
        "createProjectModel": "Create a template",
        "strategicImpact": "Strategical impact",
        "move": "Move",
        "remove": "Remove"
      }
    },
    "reportsPage": {
      "thisWeek": "This week",
      "thisMonth": "This month",
      "others": "Less recent",
      "author": "Submitted by",
      "submissionDate": "Last report",
      "zone": "Zone",
      "sortOptions": {
        "title": "Sort by",
        "optionOne": "Most recent",
        "optionTwo": "The oldest"
      },
      "filterOptions": {
        "title": "Filter by",
        "button": "Clear filter",
        "placeholder": "Search",
        "projects": "Projects",
        "tags": "Project tags",
        "allProjects": "All projects",
        "placeholderResource": "Everyone"
      }
    },
    "createProject": "Project"
  },
  "zonesPage": {
    "projectDetails": "Details",
    "addProject": "Project",
    "addZone": "Zone",
    "edit": "Edit",
    "remove": "Remove",
    "navigation": {
      "zones": "Zones",
      "projects": "Projects",
      "list": "List",
      "gantt": "Gantt",
      "reports": "Reporting",
      "workloads": "Workload"
    },
    "sort": {
      "title": "Sort by :",
      "latest": "The latest",
      "oldest": "The oldest"
    },
    "filter": {
      "title": "Filter by :",
      "placeholderZones": "All zones",
      "placeholderResources": "Everyone"
    },
    "reportsPage": {
      "thisWeek": "This week",
      "thisMonth": "This month",
      "others": "Less recent",
      "author": "Submitted by",
      "submissionDate": "Last report",
      "zone": "Zone"
    },
    "zones": {
      "heading": {
        "zone": "Zone project",
        "projectNbr": "Projects number",
        "weather": "Weather"
      },
      "edit": "Edit",
      "remove": "Remove"
    },
    "projects": {
      "title": "Projects in the zone",
      "zoneTitle": "{{name}} ({{count}})",
      "average": "avr",
      "labels": {
        "projectName": "Project name",
        "dates": "Dates",
        "startDate": "Start",
        "endDate": "End",
        "avgScore": "Strat. score",
        "score": "Strat. score",
        "status": "Status",
        "weather": "Weather",
        "activityMonitoring": {
          "title": "Activity monitoring",
          "done": "Done",
          "delayed": "Delayed",
          "opened": "Opened"
        },
        "workload": {
          "title": "Work",
          "allocatedTime": "Allocated",
          "spentTime": "Spent",
          "remainingWork": "Remaining",
          "remainingWorkShort": "TbD"
        },
        "budget": {
          "title": "Budget",
          "plannedBudget": "Planned",
          "realCosts": "Real costs",
          "acquiredValue": "Acquired"
        }
      },
      "filterPlaceholder": "Any projects",
      "createProject": "Project",
      "editZone": "Edit",
      "removeZone": "Remove",
      "sorter": {
        "title": "Sort by :",
        "default": "No sorting",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Start date",
        "endDate": "End date",
        "completionDate": "Completion date",
        "creationDate": "Creation date"
      },
      "filters": {
        "title": "Filter by :",
        "placeholderZone": "All projects",
        "placeholderResource": "Everyone",
        "showProjectsOf": "Show projects of"
      },
      "contextualMenu": {
        "projectDetails": "Project details",
        "projectStatus": "Handle status",
        "createProjectModel": "Create a template",
        "strategicImpact": "Strategical impact",
        "move": "Move",
        "remove": "Remove"
      }
    }
  },
  "listRetrieval": {
    "tasks": "tasks",
    "startDate": "Start",
    "endDate": "End",
    "description": "Description",
    "copyUrl": "Copy link",
    "secondaryCriteria": "Custom fields",
    "edit": "Edit",
    "move": "Move",
    "remove": "Delete"
  },
  "planzoneParametersPage": {
    "title": "Planzone parameters",
    "organization": {
      "title": "Information on the organization",
      "name": "Name of the entity",
      "type": "Type",
      "mainAddress": "Main address",
      "street": "Street",
      "zipCode": "Zip Code",
      "city": "City",
      "state": "State",
      "country": "Country",
      "read": "Cancel",
      "write": "Modify",
      "submit": "Register"
    },
    "timeAllocation": {
      "title": "Timesheet entry possibilities :",
      "description": "In this table, define the timesheet views used to enter times :",
      "personalTimeSheet": "Personnal timesheet",
      "groupTimeSheet": "Project timesheet (accessible to project managers only)",
      "managerTimeSheet": "Timesheet manager (can be configured from the resource profile)",
      "entry": "Entry",
      "approval": "Approval"
    },
    "settings": {
      "title": "Preferences",
      "sections": {
        "timeTracking": "Time tracking",
        "planning": "Planning",
        "collaboratorPermissions": "Collaborator project role permissions",
        "system": "System"
      },
      "lockWeeklyCalendarForNonAdmin": "Disable work calendar for non administrator users",
      "hideProjectStatsInProjectListing": "Hide activity and work tracking info in Portfolio view, Global project listing view and Zone project listing view for non administrators",
      "areTimeSheetsAutoIntegrated": "Activate automatic timesheet integration",
      "areUsersNotifiedAfterAccountCreation": "Send an automatic invitation email when a new member is invited",
      "workersCanCreateTask": "Collaborators in a project can create a task",
      "workersCanEditTask": "Collaborators in a project can edit a task",
      "workersCanRemoveTask": "Collaborators in a project can delete a task",
      "workersCanCreateList": "Collaborators in a project can create a list",
      "workersCanEditList": "Collaborators in a project can edit a list",
      "workersCanRemoveList": "Collaborators in a project can delete a list",
      "workersCanCreateMilestone": "Collaborators in a project can create a milestone",
      "workersCanEditMilestone": "Collaborators in a project can edit a milestone",
      "workersCanRemoveMilestone": "Collaborators in a project can delete a milestone",
      "workersCanCreateEvent": "Collaborators in a project can create an event",
      "workersCanEditEvent": "Collaborators in a project can edit an event",
      "workersCanRemoveEvent": "Collaborators in a project can delete an event",
      "conserveElementDuration": "Moving a project item to a non-working period will extend its duration by a number of days corresponding to the total number of non-working days included in this period",
      "showTaskCompletionPercentage": "Show task completion percentage in timesheets",
      "enterTimeAllocationInDays": "Enter the time allocation in days.",
      "allowDataScrapingForDebug": "Do you allow us to retrieve error reports to troubleshoot your Planzone?",
      "enableSelfAssignmentButton": "Enable self-assignment button to Planzone tasks in personal timesheet for all users",
      "syncAllocationDurationWithTask": "Link allocated hours to task duration",
      "lockBeforeIntegrationDate": "Lock time entries on integrated dates",
      "warnOnDailyCriticalAmplitude": "Show a warning when the assigned resource(s) exceed a critical daily work amplitude",
      "warnOnDailyCriticalVolume": "Show a warning when the assigned resource(s) exceed a critical daily work volume",
      "warnOnInsufficientRestPeriod": "Alert if the rest period between the end of the last activity and the start of the first one the next day is below the configured threshold",
      "warnOnUnavailability": "Show a warning when an assigned resource has an unavailability overlapping the task period"
    },
    "areaRestrictions": {
      "title": "View"
    },
    "calendarHolidays": {
      "title": "Holiday Calendars",
      "subTitleDefaultCalendar": "Default holiday calendar",
      "subTitle": "Custom calendars",
      "submit": "Add a calendar",
      "placeholder": "Choose",
      "defaultHint": "Automatically applied to new projects in this planzone.",
      "holidaysCountSingular": "{{count}} public holiday",
      "holidaysCountPlural": "{{count}} public holidays",
      "noHolidays": "No public holidays",
      "emptyState": "No custom calendar yet.",
      "defaultBadge": "Default",
      "editAction": "Rename calendar",
      "removeAction": "Delete calendar"
    },
    "logs": {
      "title": "Logs",
      "redirection": "Access to logs"
    },
    "resourceUsageReport": {
      "title": "Planzone Usage Report",
      "subTitle": "User login report for the current Planzone by day",
      "startDate": "Start Date",
      "endDate": "End Date",
      "download": "Download"
    },
    "identityProviders": {
      "title": "SSO",
      "cas": {
        "loginUrl": {
          "label": "Login URL",
          "placeholder": "Login URL"
        },
        "protocol": {
          "label": "Protocol",
          "placeholder": "Protocol"
        },
        "clientName": {
          "label": "Client name",
          "placeholder": "Client name"
        },
        "enabled": "Enable"
      },
      "azure": {
        "clientId": {
          "label": "Client ID",
          "placeholder": "Client ID"
        },
        "clientSecret": {
          "label": "Client secret",
          "placeholder": "Client secret"
        },
        "tenant": {
          "label": "Tenant",
          "placeholder": "Tenant"
        },
        "discoveryUri": {
          "label": "Discovery URI",
          "placeholder": "Discovery URI"
        },
        "scope": {
          "label": "Scope",
          "placeholder": "Scope"
        },
        "callbackUrlType": {
          "label": "Callback url type",
          "placeholder": "Callback url type"
        },
        "loginUrl": {
          "label": "Login URL",
          "placeholder": "Login URL"
        },
        "clientName": {
          "label": "Client name",
          "placeholder": "Client name"
        },
        "displayName": {
          "label": "Display name",
          "placeholder": "Display name"
        },
        "principalAttributeId": {
          "label": "Principal attribute id",
          "placeholder": "Principal attribute id"
        },
        "enabled": "Enable"
      },
      "tutorial": {
        "message": "You have not configured your SSO. Would you like to configure your SSO?",
        "configure": "Configure"
      },
      "addProvider": "Add",
      "remove": "Remove",
      "edit": "Update"
    },
    "api": {
      "title": "API",
      "link": "API access"
    },
    "timesheetDeadline": {
      "title": "Timesheet Deadline",
      "description": "Set a date after which past time entries can no longer be modified or entered.",
      "placeholder": "Select date and time"
    }
  },
  "documentsPage": {
    "title": "Documents",
    "reportsPage": {
      "filters": {
        "show": "Show",
        "author": "Filter by",
        "date": "Sort by",
        "resetFilter": "Reset filters",
        "newestReportsFilter": "Newest",
        "oldestReportsFilter": "Oldest",
        "all": "All"
      },
      "header": {
        "name": "Label",
        "submissionDate": "Submission date",
        "author": "Reporter",
        "indicators": "Indicators"
      },
      "remove": "Remove",
      "duplicate": "Duplicate",
      "export": "Export"
    },
    "documentsPage": {
      "header": {
        "name": "Name",
        "createdBy": "Created by",
        "creationDate": "Created at"
      },
      "elementCreationMenu": {
        "button": "Add",
        "uploadDocument": "File",
        "createFolder": "Folder"
      },
      "placeholder": {
        "title": "Your document management space is empty",
        "addElement": "Would you like to add an item ?"
      },
      "templateFolder": "Document templates",
      "download": "Download",
      "rename": "Rename",
      "remove": "Remove",
      "move": "Move",
      "edit": "Edit",
      "addToTemplates": "Create template"
    },
    "sideBar": {
      "reports": "Reports",
      "folder": "Files"
    }
  },
  "planzoneMembersPage": {
    "title": "Members list",
    "organizationalUnit": {
      "none": "No unit"
    },
    "addResource": "Resource",
    "addMaterialResource": "Material resource",
    "inviteMembers": "Invite a member",
    "addVirtualResource": "Virtual resource",
    "groupsTitle": "Groups",
    "rolesTitle": "All members",
    "resourceTypesFilterTitle": "Resources",
    "toggleView": "Groups",
    "filters": {
      "title": "Filter by :",
      "button": "Clear filter",
      "default": "No filter",
      "allProjects": "All projects",
      "projectDropdown": "Projects",
      "tagDropdown": "Tags"
    },
    "sorters": {
      "title": "Sort by :",
      "default": "No sorting (default)",
      "name": "Name",
      "role": "Role",
      "creationDate": "Date of entry"
    },
    "resources": {
      "name": "Name",
      "role": "Role",
      "tags": "Tags",
      "humanResource": "Human",
      "materialResource": "Material",
      "virtualResource": "Virtual",
      "activeResource": "Actives",
      "inactiveResource": "Inactives",
      "invitationStatus": "Status",
      "pending": "Pending invitation",
      "subordinates": "Manages the times of",
      "organizationalUnit": "Organizational unit",
      "edit": "Edit",
      "activate": "Activate",
      "disable": "Disable",
      "clearSubordinates": "Clear"
    },
    "export": "Export",
    "workbookName": "Resources_for_"
  },
  "projectResourcesPage": {
    "title": "Members list",
    "addResource": "Resource",
    "addMaterialResource": "Material resource",
    "addVirtualResource": "Virtual resource",
    "toggleViewButton": "Groups",
    "filters": {
      "sort": "Sort by :",
      "noSort": "No sorting (by default)",
      "lastNameSort": "Name",
      "firstNameSort": "Firstname",
      "roleSort": "Role",
      "entryDateSort": "Entry date",
      "filter": "Filter by :",
      "defaultFilter": "All"
    },
    "export": "Export",
    "workbookName": "Resources_for_"
  },
  "capacityPage": {
    "title": "Capacity",
    "toolbar": {
      "monthlyView": "Monthly view",
      "weeklyView": "Weekly view",
      "sortTitle": "Sort by:",
      "filterTitle": "Filter:",
      "filterPlaceholder": "All resources",
      "unit": "Unit",
      "helpTitle": "Capacity",
      "help": "This view lets you check your resources' <bold>availability</bold> in Planzone. By default it relies on each team member's <bold>individual weekly calendar</bold>, automatically deducting <bold>public holidays</bold> and <bold>absences</bold>. You can still add <bold>one-off capacity exceptions</bold> if needed."
    },
    "sorters": {
      "alphabetical": "Alphabetical",
      "role": "Role",
      "creationDate": "Creation date",
      "type": "Type"
    },
    "table": {
      "resource": "Resource"
    },
    "empty": "No resources to display.",
    "error": "An error occurred while loading capacity.",
    "retry": "Retry"
  },
  "workloadPage": {
    "title": "Forecast workload",
    "toolbar": {
      "monthlyView": "Monthly view",
      "weeklyView": "Weekly view",
      "sortTitle": "Sort by:",
      "filterTitle": "Filter:",
      "filterPlaceholder": "All resources",
      "unit": "Unit",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "helpTitle": "Forecast workload view",
      "help": "This view lets you edit your resources' forecast workload on their projects while keeping direct visibility on their capacity (shown side by side: workload on the left, capacity on the right).\n\n<bold>Note:</bold> Forecast workload is independent from \"standard\" workload and is not included in the workload calculations of the <bold>Gantt</bold> and <bold>Workload</bold> views."
    },
    "sorters": {
      "alphabetical": "Alphabetical",
      "role": "Role",
      "creationDate": "Creation date",
      "type": "Type"
    },
    "table": {
      "resource": "Resource",
      "detailEmpty": "No projects to display.",
      "detailError": "An error occurred while loading the project breakdown."
    },
    "empty": "No resources to display.",
    "error": "An error occurred while loading workload.",
    "retry": "Retry"
  },
  "occupancyPage": {
    "title": "Occupancy rate",
    "toolbar": {
      "monthlyView": "Monthly view",
      "weeklyView": "Weekly view",
      "sortTitle": "Sort by:",
      "filterTitle": "Filter:",
      "filterPlaceholder": "All resources",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "helpTitle": "Occupancy rate view",
      "help": "This view lets you analyze your resources' <bold>occupancy rate</bold> over the period of your choice, with a detailed breakdown by project.\n\nTo help you quickly spot <bold>underload</bold> and <bold>overload</bold>, a <bold>dynamic color code</bold> is applied:\n\n<green>Green</green>: workload of 100% or less (optimal or available occupancy).\n<orange>Orange</orange>: workload between 101% and 130% (moderate overload to monitor).\n<red>Red</red>: workload above 130% (critical overload requiring arbitration)."
    },
    "sorters": {
      "alphabetical": "Alphabetical",
      "role": "Role",
      "creationDate": "Creation date",
      "type": "Type"
    },
    "table": {
      "resource": "Resource",
      "overload": "Workload without capacity",
      "detailEmpty": "No projects to display.",
      "detailError": "An error occurred while loading the project breakdown."
    },
    "empty": "No resources to display.",
    "error": "An error occurred while loading the occupancy rate.",
    "retry": "Retry"
  },
  "costProfilesPage": {
    "title": "List of cost profiles",
    "add": "Profile",
    "name": "Name",
    "affiliation": "Type",
    "costProfile": "Profile",
    "sidebar": {
      "allMembers": "All members",
      "internal": "Internal",
      "external": "External",
      "costProfiles": "Profiles",
      "edit": "Edit",
      "remove": "Remove"
    },
    "hour": "hour"
  },
  "createCostProfile": {
    "title": "Create a new cost profile",
    "name": "Profile name (required)",
    "cost": "Hourly cost",
    "costLabel": "€/hour",
    "description": "Description",
    "cancel": "Cancel",
    "submit": "Create"
  },
  "duplicateList": {
    "title": "Duplicate the {{-name}} list",
    "message": "The list and its sub-elements will be duplicated",
    "cancel": "Cancel",
    "submit": "Duplicate"
  },
  "editCostProfile": {
    "title": "Edit a cost profile",
    "name": "Profile name (required)",
    "cost": "Daily cost",
    "costLabel": "€/hour",
    "description": "Description",
    "cancel": "Cancel",
    "submit": "Edit",
    "costProfileTitle": "History",
    "dailyCost": "Hourly cost",
    "costStartDate": "Effective date",
    "addCost": "Add"
  },
  "projectPage": {
    "menu": {
      "projectDetails": "Project details",
      "projectStatus": "Handle status",
      "createProjectModel": "Create a template",
      "strategicImpact": "Strategical impact",
      "move": "Move",
      "duplicate": "Duplicate",
      "secondaryCriteria": "Local custom fields",
      "logs": "Project logs",
      "remove": "Remove"
    },
    "navigation": {
      "members": "Team",
      "discussions": "Discussions",
      "reports": "Documents",
      "budget": "Budget",
      "reportsExports": "Reports"
    },
    "elementCreationMenu": {
      "button": "Create",
      "createList": "List of tasks",
      "createTask": "Task",
      "createMilestone": "Milestone",
      "createEvent": "Event"
    },
    "tasks": "tasks",
    "list": "List",
    "subList": "Sub-list",
    "toggle": "Status",
    "toggleList": "List",
    "tasksHeading": {
      "name": "Name",
      "tags": "Tags",
      "status": "Status",
      "assignees": "Assignees",
      "endDate": "End date",
      "taskAdvancement": "Completion"
    },
    "tasksContextualMenu": {
      "copyUrl": "Copy link",
      "edit": "Edit",
      "move": "Move",
      "duplicate": "Duplicate",
      "remove": "Delete"
    },
    "synthesisPage": {
      "milestones": {
        "title": "Milestones",
        "placeholder": "You don't have any late or upcoming milestones."
      },
      "monitoring": {
        "title": "Time recording",
        "today": "Today",
        "doneTitle": "Realized",
        "overDueTitle": "Late",
        "openedTitle": "Started",
        "allocatedTime": "Allocated",
        "workedHours": "Passed",
        "openedWorkHours": "Remains to be done",
        "doneMilestones": "Milestones achieved",
        "doneTasks": "Completed tasks",
        "endDate": "End date",
        "start": "Start",
        "end": "End",
        "fallBack": "Nothing is planned in this project",
        "completionDate": "Completion date"
      },
      "overDueTasks": {
        "title": "Overdue tasks",
        "placeholder": "No overdue task",
        "myPlaceholder": "No overdue task for you"
      },
      "upComingTasks": {
        "title": "Upcoming tasks",
        "placeholder": "No task ahead",
        "myPlaceholder": "No task ahead for you"
      },
      "tasks": {
        "me": "Me",
        "everyone": "Everyone"
      },
      "latestReports": "Latest reports",
      "description": "Description",
      "submitFlashReport": "Flash report",
      "submitReport": "Make a report",
      "strategicScore": "Strategic score",
      "reports": {
        "empty": "There is no report on the project yet",
        "header": {
          "name": "Label",
          "submissionDate": "Date",
          "author": "Reporter",
          "indicators": "Indicators"
        },
        "by": "by"
      },
      "pdfExport": {
        "title": "Flash report",
        "in": "in",
        "createdOn": "Created on :",
        "by": "By :",
        "form": {
          "title": "Create a flash report",
          "projectName": "Flash report of project ",
          "object": "Object",
          "addReport": "Include a report",
          "chooseReport": "Choose a reporting",
          "noReport": "You have no report in the project",
          "reportPlaceholder": "Select a report",
          "cancel": "Cancel",
          "submit": "Export",
          "generating": "Generating..."
        },
        "synthesis": {
          "title": "Project Information",
          "weather": "Weather",
          "owner": "Owner",
          "description": "Project description",
          "startDate": "Start",
          "endDate": "End",
          "projectStatus": "Status",
          "portfolio": "Portfolio(s)",
          "strategicScore": "Strategic score",
          "tags": "Tag(s)"
        },
        "secondaryCriteria": {
          "title": "Custom fields"
        },
        "object": {
          "title": "Object"
        },
        "project": {
          "title": "Project"
        },
        "zone": {
          "title": "In the zone :"
        },
        "report": {
          "title": "Included report",
          "at": "at :",
          "by": "by :",
          "indicators": "Indicators"
        },
        "milestones": {
          "title": "Milestones",
          "endDate": "Planned",
          "completionDate": "Actual"
        },
        "timeRecording": {
          "title": "Time recording :"
        }
      }
    },
    "listsPage": {
      "title": "Lists",
      "toggle": {
        "wbs": "List",
        "statuses": "Status"
      },
      "filters": {
        "dataType": {
          "list": "Lists",
          "task": "Tasks",
          "milestone": "Milestones",
          "event": "Events",
          "show": "Show",
          "completedWork": "Work done",
          "startedElement": "Tasks started",
          "notStartedElement": "Unstarted tasks",
          "seeDataType": "Show :",
          "allDataType": "All"
        },
        "show": "Show",
        "seeTasksOf": "See the tasks of",
        "resetFilters": "Reset",
        "me": " (Me)",
        "resourcesFilterTitle": "Resources",
        "groupsFilterTitle": "Groups",
        "tagsFilterTitle": "Resource tags",
        "allResources": "Everyone",
        "sorter": {
          "title": "Sort by :",
          "default": "No sorting (default)",
          "startingDate": "Start date",
          "endDate": "End date",
          "completionDate": "Date of completion",
          "creationDate": "Creation date"
        }
      },
      "sorts": {
        "title": "filtered by :",
        "ascendingRank": "Unsorted",
        "ascendingName": "A > Z",
        "descendingName": "Z > A",
        "ascendingStartDate": "Start date",
        "ascendingEndDate": "End date",
        "ascendingCompletionDate": "Completion date",
        "zone": "Zones"
      },
      "export": "Export",
      "completionDate": "real",
      "statuses": {
        "emptyList": "No task"
      }
    },
    "documentsPage": {
      "title": "Documents",
      "reportsPage": {
        "filters": {
          "show": "Show",
          "author": "Filter by",
          "date": "Sort by",
          "resetFilter": "Reset filters",
          "newestReportsFilter": "Newest",
          "oldestReportsFilter": "Oldest",
          "all": "All"
        },
        "header": {
          "name": "Label",
          "submissionDate": "Submission date",
          "author": "Reporter",
          "indicators": "Indicators"
        },
        "remove": "Remove",
        "duplicate": "Duplicate",
        "export": "Export"
      },
      "documentsPage": {
        "header": {
          "name": "Name",
          "createdBy": "Created by",
          "creationDate": "Created at"
        },
        "elementCreationMenu": {
          "button": "Add",
          "uploadDocument": "File",
          "createFolder": "Folder"
        },
        "placeholder": {
          "title": "Your document management space is empty",
          "addElement": "Would you like to add an item ?"
        },
        "download": "Download",
        "rename": "Rename",
        "remove": "Remove",
        "move": "Move",
        "edit": "Edit",
        "addToTemplates": "Create template"
      },
      "sideBar": {
        "reports": "Reports",
        "folder": "Files"
      }
    },
    "ganttPage": {
      "title": "Gantt",
      "viewSelection": {
        "daily": "Daily view",
        "weekly": "Daily view",
        "monthly": "Monthly view",
        "yearly": "Yearly view"
      },
      "displayOverdueTasks": "Overdue tasks",
      "week": "W",
      "projectEdition": {
        "title": "Display of the gantt",
        "message": "To display the Gantt view, please enter a start and end date for your project.",
        "define": "Define",
        "startDate": "as start date",
        "endDate": "as end date",
        "confirm": "Validate"
      },
      "sorts": {
        "default": "Unsorted",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Start date",
        "endDate": "End date",
        "completionDate": "Completion date"
      },
      "filters": {
        "dataType": {
          "list": "Lists",
          "task": "Tasks",
          "milestone": "Milestones",
          "startedElement": "Tasks started",
          "notStartedElement": "Unstarted tasks",
          "show": "Show",
          "doneElement": "Work done",
          "event": "Events",
          "startElement": "Tasks started",
          "notStartElement": "Unstarted tasks",
          "allDataType": "All"
        },
        "seeTasksOf": "Filter by",
        "zonesPlaceholder": "All zones",
        "zonePlaceholder": "All projets",
        "resourcePlaceholder": "Everybody",
        "placeholder": "Everyone",
        "resetFilter": "Reset",
        "sorter": {
          "title": "Sort by :",
          "default": "No sorting (default)",
          "startingDate": "Start date",
          "endDate": "End date",
          "completionDate": "Date of completion",
          "creationDate": "Creation date"
        }
      },
      "moveToToday": "Go to today",
      "allocations": {
        "title": "Assigned resources",
        "estimatedHours": "Estimated",
        "allocatedHours": "Allocated",
        "completion": "% Done"
      }
    },
    "discussionsPage": {
      "title": "Discussions",
      "add": "Discussion",
      "comments": "comment(s)",
      "remove": "delete"
    },
    "externalLinksList": {
      "edit": "Edit link",
      "remove": "Remove link"
    }
  },
  "secondaryCriteriaTemplate": {
    "title": "Local custom fields",
    "add": "Add",
    "remove": "Remove",
    "views": {
      "title": "Elements concerned",
      "project": "Projects",
      "resource": "Resources",
      "projectElement": "Project elements",
      "projectReport": "Project reports",
      "timeRecord": "Time record"
    },
    "form": {
      "type": {
        "label": "Type",
        "placeholder": "Type your criterion",
        "types": {
          "number": "Number",
          "text": "Text",
          "richText": "Rich text",
          "date": "Date",
          "list": "List",
          "document": "Image",
          "link": "Link",
          "resource": "Resource"
        }
      },
      "name": {
        "label": "Name",
        "placeholder": "Name your criterion",
        "translations": "Translations",
        "defaultName": "Unnamed"
      },
      "accessRoles": {
        "label": "Permissions",
        "read": "Who can see the data",
        "write": "Who can modify the data"
      },
      "options": {
        "label": "Options",
        "multiple": "Multiple selection",
        "required": "Requis",
        "add": "Add"
      },
      "reset": "Reset",
      "submit": "Edit",
      "cancel": "Cancel"
    }
  },
  "editSecondaryCriteriaTemplate": {
    "title": "Delete your secondary criteria",
    "message": "Please note that you are about to delete a secondary criterion. Deleting your secondary criterion is definitive and will result in the deletion of all associated data. Are you sure you want to continue?",
    "cancel": "Cancel",
    "confirm": "Remove"
  },
  "utilityPage": {
    "title": "Customization",
    "navigation": {
      "projects": "Projects status",
      "projectReportTemplate": "Reporting template",
      "projectModels": "Project templates",
      "secondaryCriteriaTemplate": "Custom fields"
    },
    "projectPage": {
      "projectStatuses": {
        "title": "Project status management",
        "subTitle": "Add or delete project statuses.",
        "placeholder": "Naming a status",
        "errorName": "The name must not exceed 256 characters"
      }
    },
    "projectReportTemplatePage": {
      "indicators": "Custom indicators",
      "fields": "Fields",
      "addField": "Add a field",
      "emptyFieldsDropzone": "Drag a field or criteria here, or add a field below",
      "indicatorsForm": {
        "placeholder": "Name of the indicator"
      },
      "textFieldsForm": {
        "placeholder": "Ex : Next step"
      },
      "save": "Save the model",
      "criteria": "Custom criteria",
      "addTemplate": "Add template",
      "removeTemplate": "Remove template",
      "templateName": "Template name",
      "templateNamePlaceholder": "Enter template name"
    }
  },
  "calendarPage": {
    "monthlyView": "Month",
    "weeklyView": "Week",
    "dailyView": "Day",
    "showMoreEvents": "Plus",
    "showLessEvents": "Less",
    "to": "to",
    "sideBar": {
      "title": "Your calendars",
      "elementTypeFilter": {
        "label": "Show",
        "task": "Tasks",
        "milestone": "Milestones",
        "event": "Events",
        "unavailability": "Unavailabilities"
      }
    },
    "filters": {
      "title": "Filter by",
      "zoneDefault": "All zones",
      "resourceDefault": "Everyone",
      "dataType": {
        "placeholder": "Element types",
        "task": "Tasks",
        "milestone": "Milestones",
        "event": "Events",
        "unavailability": "Unavailabilities"
      }
    },
    "exports": {
      "export": "Export calendar"
    }
  },
  "exportReportsPage": {
    "title": "Reports / Exports",
    "subTitle": "Create a report",
    "description": "Select desired options to create the report",
    "reportType": {
      "title": "Select the type of report",
      "subTitle": "Select one of the options below"
    },
    "resourceProjectAllocationReport": {
      "title": "Monthly Work Time Summary",
      "name": "Monthly Time Management Report",
      "subTitle": "Detailed tracking of allocated time distributed each month, enabling better management and optimization of hourly resources.",
      "startDate": "Start"
    },

    "resourceReport": {
      "name": "Planzone resources report",
      "title": "Planzone resources",
      "subTitle": "List of all planzone resources and their attributes",
      "download": "Download",
      "projectName": "Project members report ",
      "projectTitle": "Project members",
      "projectSubTitle": "List of the project's members and their attributes"
    },
    "dailyPlanningReport": {
      "name": "Project daily planning",
      "title": "Daily planning",
      "subTitle": "The project's Gantt chart in daily view, over the selected date range",
      "startDate": "Start",
      "endDate": "End",
      "elementTypes": "Element types:",
      "columns": "Show:"
    },
    "resourceAllocatedTimeReport": {
      "name": "Resources allocated time report of",
      "title": "Resources allocated time",
      "subTitle": "Time allocated to each resource per day, derived from its weekly calendar and remaining capacity",
      "startDate": "Start",
      "endDate": "End"
    },
    "biExportReport": {
      "title": "BI export",
      "subTitle": "Generates the CSV files (projects, tasks, resources, allocations, timesheets, expenses, cost profiles) of the period and stores them in the planzone documents",
      "startDate": "Start",
      "endDate": "End",
      "launch": "Start export",
      "invalidRange": "Start date must be before or equal to end date",
      "openDocuments": "Open documents",
      "status": {
        "PENDING": "Pending",
        "RUNNING": "Running",
        "COMPLETED": "Completed",
        "PARTIAL": "Partially completed",
        "FAILED": "Failed"
      }
    },
    "wbsZonesReport": {
      "name": "global report of Planzone : ",
      "title": "Project Tasks",
      "subTitle": "A list of Planzone zones, including their projects and associated task lists",
      "filters": {
        "title": "Filter by :",
        "zoneDefault": "All zones",
        "resourceDefault": "Everyone",
        "dataType": {
          "list": "Lists",
          "task": "Tasks",
          "milestone": "Milestones",
          "event": "Events",
          "show": "Show",
          "doneElement": "Work done",
          "startedElement": "Tasks started",
          "notStartedElement": "Unstarted tasks",
          "seeDataType": "Show :",
          "allDataType": "All"
        },
        "show": "Show",
        "seeTasksOf": "See the tasks of",
        "resetFilters": "Reset",
        "me": " (Me)",
        "resourcesFilterTitle": "Resources",
        "groupsFilterTitle": "Groups",
        "tagsFilterTitle": "Resource tags",
        "allResources": "Everyone"
      },
      "sorts": {
        "title": "Sort by :",
        "default": "No sorting",
        "ascendingAlphabeticalOrder": "A > Z",
        "descendingAlphabeticalOrder": "Z > A",
        "startDate": "Start date",
        "endDate": "End date",
        "completionDate": "Completion date",
        "creationDate": "Creation date"
      }
    },
    "timeSheetReport": {
      "name": "Timesheet by project report",
      "title": "Global timesheet by project",
      "subTitle": "Total time spent by Planzone resources over a given period of time per project",
      "startDate": "Start",
      "endDate": "End",
      "download": "Download",
      "exportLabel": "Export:",
      "integrationDateFilterAll": "All",
      "filterByResourceIntegrationDate": "Up to resource integration date",
      "filterByProjectIntegrationDate": "Up to project integration date",
      "views": {
        "monthly": "Monthly view",
        "weekly": "Weekly view",
        "daily": "Daily view"
      }
    },
    "timeSheetByTaskReport": {
      "name": "Global timesheet by task of ",
      "title": "Global timesheet by task",
      "subTitle": "Total time spent by Planzone resources on a given task over a given period of time",
      "startDate": "Start",
      "endDate": "End",
      "download": "Download",
      "exportLabel": "Export:",
      "integrationDateFilterAll": "All",
      "filterByResourceIntegrationDate": "Up to resource integration date",
      "filterByProjectIntegrationDate": "Up to project integration date",
      "views": {
        "monthly": "Monthly view",
        "weekly": "Weekly view",
        "daily": "Daily view"
      }
    },
    "customCpamReport": {
      "title": "CPAM Report",
      "name": "CPAM Report ",
      "year": "Year",
      "projects": "Zone / Project(s)",
      "filterDefault": "All zones",
      "resetFilters": "Reset"
    },
    "taskBudgetReport": {
      "name": "Allocated and spent time tracking by project of ",
      "title": "Allocated and spent time tracking by project",
      "subTitle": "For each task in your projects: allocated time, spent time (all resources combined) and remaining time. One tab per project.",
      "stopDate": "Cut-off date",
      "filters": {
        "title": "Filter by: ",
        "projectDefault": "All projects",
        "resetFilters": "Reset"
      }
    },
    "download": "Download"
  },
  "inviteMembers": {
    "title": "Invite new members",
    "message": "Enter one or more email addresses of the people you would like to invite to join your project team. You can send them a personalised message in the section below.",
    "emailTitle": "Email (required)",
    "nameTitle": "Fullname (required)",
    "roleTitle": "Role",
    "messageTitle": "Message",
    "emailPlaceholder": "Email",
    "lastNamePlaceholder": "Last name",
    "firstNamePlaceholder": "First name",
    "languagePlaceholder": "Language",
    "rolePlaceholder": "Role",
    "messagePlaceholder": "I'd like you to join Planzone « {{planzone}} ».",
    "duplicatedInvitation": "This member has already been invited.",
    "invalidEmail": "You have to provide a valid e-mail address.",
    "invalidName": "You have to provide a name.",
    "emptyRole": "You have to provide a role.",
    "addMember": "Add a member",
    "cancel": "Cancel",
    "confirm": "Send"
  },
  "documentUpload": {
    "title": "Import files",
    "message": "Drag and drop your documents here",
    "placeholder": "Select documents"
  },
  "listCreation": {
    "submit": "Submit",
    "cancel": "Cancel",
    "title": "Create a list of tasks",
    "nameTitle": "Name the list",
    "namePlaceholder": "Give the list a name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Start",
    "startDatePlaceholder": "Select a date",
    "endDateTitle": "End",
    "endDatePlaceholder": "Select a date",
    "parentListTitle": "Is part of",
    "parentListPlaceholder": "Choose a list"
  },
  "projectPortfolioCreation": {
    "title": "Create a project portfolio",
    "nameTitle": "Name the portfolio",
    "namePlaceholder": "Name the portfolio.",
    "projectSelectionTitle": "Select projects",
    "projectSelectionPlaceholder": "Select one or more projects",
    "descriptionTitle": "Description (optional)",
    "descriptionPlaceholder": "",
    "submit": "Submit",
    "cancel": "Cancel"
  },
  "projectPortfolioEdition": {
    "title": "Edit a project portfolio",
    "nameTitle": "Name the portfolio",
    "namePlaceholder": "Name the portfolio.",
    "projectSelectionTitle": "Select projects",
    "projectSelectionPlaceholder": "Select one or more projects",
    "descriptionTitle": "Description (optional)",
    "descriptionPlaceholder": "",
    "submit": "Save",
    "cancel": "Cancel"
  },
  "milestoneCreation": {
    "submit": "Submit",
    "cancel": "Cancel",
    "title": "Create a milestone",
    "nameTitle": "Name the milestone",
    "namePlaceholder": "Give the milestone a name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "endDateTitle": "End",
    "endDatePlaceholder": "Select a date",
    "parentListTitle": "Is part of",
    "parentListPlaceholder": "Choose a list",
    "projectSelectionPlaceholder": "Select a project",
    "inProject": "In the project"
  },
  "accessRestrictionsEdition": {
    "personalSynthesis": "My space > My overview",
    "personalTimesheet": "My space > Time recording",
    "resources": "Management > Resources",
    "costProfiles": "Management > Profiles",
    "projectTemplates": "Customization > Project templates",
    "projectReportsTemplate": "Customization > Reporting template",
    "projectStatuses": "Customization > Projects statuses",
    "secondaryCriteriaTemplate": "Customization > Custom fields",
    "strategicAxes": "Customization > Strategic axes",
    "portfolios": "Portfolios",
    "calendar": "Calendar",
    "documents": "Documents",
    "exports": "Reports / exports",
    "onlyOffice": "Document creation/edition",
    "capacity": "Management > Capacity",
    "workload": "Management > Workload",
    "occupancy": "Management > Occupancy rate"
  },
  "portfolioAssignation": {
    "search": "Search",
    "add": "+ Add a portfolio",
    "name": "Name the portfolio"
  },
  "listEdition": {
    "submit": "Submit",
    "cancel": "Cancel",
    "nameTitle": "Name the list",
    "namePlaceholder": "Give the list a name",
    "descriptionTitle": "Description",
    "descriptionPlaceholder": "",
    "startDateTitle": "Start",
    "startDatePlaceholder": "Select a date",
    "endDateTitle": "End",
    "endDatePlaceholder": "Select a date",
    "parentListTitle": "Is part of",
    "parentListPlaceholder": "Choose a list"
  },
  "createStatus": {
    "addStatus": "+ Add status",
    "namePlaceholder": "Name the status",
    "noStatus": "No status"
  },
  "projectModelsPage": {
    "add": "Template",
    "edit": "Edit",
    "use": "Create a project"
  },
  "moveElement": {
    "title": "Move element",
    "submit": "Move",
    "cancel": "Cancel",
    "project": "In the project",
    "list": "In the list",
    "conserveTime": {
      "list": "Align the list start date with the new list start date",
      "task": "Align the task start date with the new list start date",
      "event": "Align the event start date with the new list start date",
      "milestone": "Align the milestone start date with the new list start date"
    }
  },
  "editResource": {
    "title": "Resource profile",
    "name": "Resource name",
    "namePlaceholder": "Resource name",
    "inputProfession": "Function in the organisation",
    "inputRole": "Role",
    "inputDescription": "Description (optional)",
    "tagsTitle": "Resource's tags",
    "affiliation": "This resource is external",
    "save": "Save",
    "cancel": "Cancel",
    "professionPlaceholder": "Function in the organisation",
    "descriptionPlaceholder": "Description",
    "addCostProfile": "Add a cost profile",
    "search": "Search",
    "projects": "Projects",
    "allocationTitle": "Manage time validation for",
    "calendarHolidaysTitle": "Holidays calendar",
    "inputCalendarHolidays": "choose a holiday calendar",
    "capacity": "Capacity",
    "addButton": "Add",
    "default": "None",
    "secondaryCriteria": "Custom fields"
  },
  "disableResource": {
    "title": "Disable resource",
    "warning": "You are about to disable a resource.",
    "save": "Save",
    "cancel": "Cancel"
  },
  "activateResource": {
    "title": "activate resource",
    "warning": "You are about to activate a resource.",
    "save": "Save",
    "cancel": "Cancel"
  },
  "editProjectResource": {
    "title": "Edit project resource",
    "inputProfession": "Function in the projet",
    "inputRole": "Role",
    "inputDescription": "Description (optional)",
    "save": "Save",
    "cancel": "Cancel",
    "professionPlaceholder": "Function in the projet",
    "descriptionPlaceholder": "Description"
  },
  "disableProjectResource": {
    "title": "Disable project resource",
    "warning": "You are about to disable a team member.",
    "save": "Save",
    "cancel": "Cancel"
  },
  "activateProjectResource": {
    "title": "activate project resource",
    "warning": "You are about to activate a team member.",
    "save": "Save",
    "cancel": "Cancel"
  },
  "addResourceGroup": {
    "title": "Create a new resource group",
    "cancel": "Cancel",
    "create": "Create",
    "form": {
      "title": "Name of the group",
      "namePlaceholder": "Name the group",
      "titleDescription": "Description",
      "titleResources": "Group members"
    },
    "sideBarName": "Project Groups"
  },
  "filterProjectResource": {
    "sideBarName": "Resources"
  },
  "editResourceGroup": {
    "title": "Edit a group",
    "cancel": "Cancel",
    "create": "Edit",
    "resourcesList": {
      "title": "Group members",
      "addResource": "+ Add a person",
      "placeholder": "Select a resource",
      "permission": "Permissions",
      "function": "Function"
    },
    "form": {
      "title": "Name the group",
      "namePlaceholder": "Name",
      "description": "Description"
    }
  },
  "projectBudgetSynthesis": {
    "title": "Budget",
    "plannedBudget": {
      "title": "Planned",
      "headers": {
        "planned": "Planned",
        "dateMonitoring": "Date monitoring",
        "total": "Total",
        "workload": "Workload"
      },
      "real": "Real",
      "acquired": "Acquired",
      "planned": "Planned",
      "budgetAllocated": "Allocated budget",
      "allocated": "Allocated",
      "past": "Past",
      "remaining": "Remaining"
    },
    "monitoring": {
      "title": "Monitoring",
      "trackingPlannedValueOfProject": "Planned Value",
      "trackingAcquiredValue": "Acquired value",
      "trackingRealCost": "Real cost",
      "percentOfBudgetConsumption": "Budget cons.",
      "percentOfAcquiredValue": "Acquired value"
    },
    "workload": {
      "title": "Work"
    },
    "expensesBreakdownByExpenseType": {
      "title": "Breakdown of expenses by type of expense"
    },
    "costsBreakdownByResourceType": {
      "title": "Breakdown of costs by type of resource",
      "costs": "Costs",
      "external": "External",
      "internal": "Internal",
      "material": "Material"
    },
    "expenses": {
      "title": "Expenses list",
      "create": "Expense",
      "orderNumber": "Order number",
      "name": "Name",
      "expenseType": "Type",
      "quantity": "Qty",
      "unitAmount": "Unit qty",
      "totalAmount": "Total amount",
      "plannedDate": "Planned",
      "actualDate": "Real",
      "attachments": "Attachment(s)",
      "attachmentsAdd": "Add",
      "creation": {
        "title": "Create an expense",
        "confirm": "Save",
        "cancel": "Cancel",
        "quantity": "Quantity",
        "unitAmount": "Unit Amount",
        "expenseType": "Expense type",
        "newExpenseType": "New expense type",
        "createExpenseType": "Create"
      },
      "removal": {
        "button": "Delete",
        "title": "Are you sure you want to delete this expense ?",
        "confirmation": "This expense will be deleted and removed from the project.",
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "edition": {
        "button": "Edit",
        "title": "Create an expense",
        "confirm": "Save",
        "cancel": "Cancel",
        "quantity": "Quantity",
        "unitAmount": "Unit Amount",
        "expenseType": "Expense type",
        "newExpenseType": "New expense type",
        "createExpenseType": "Create"
      }
    }
  },
  "addIdentityProvider": {
    "title": "Add SSO",
    "cas": {
      "loginUrl": {
        "label": "Login URL",
        "placeholder": "Login URL"
      },
      "protocol": {
        "label": "Protocol",
        "placeholder": "Protocol"
      },
      "clientName": {
        "label": "Client name",
        "placeholder": "Client name"
      },
      "enabled": "Enable"
    },
    "azure": {
      "clientId": {
        "label": "Client ID",
        "placeholder": "Client ID"
      },
      "clientSecret": {
        "label": "Client secret",
        "placeholder": "Client secret"
      },
      "tenant": {
        "label": "Tenant",
        "placeholder": "Tenant"
      },
      "discoveryUri": {
        "label": "Discovery URI",
        "placeholder": "Discovery URI"
      },
      "scope": {
        "label": "Scope",
        "placeholder": "Scope"
      },
      "callbackUrlType": {
        "label": "Callback url type",
        "placeholder": "Callback url type"
      },
      "loginUrl": {
        "label": "Login URL",
        "placeholder": "Login URL"
      },
      "clientName": {
        "label": "Client name",
        "placeholder": "Client name"
      },
      "displayName": {
        "label": "Display name",
        "placeholder": "Display name"
      },
      "principalAttributeId": {
        "label": "Principal attribute id",
        "placeholder": "Principal attribute id"
      },
      "enabled": "Enable"
    },
    "submit": "Submit"
  },
  "accountPage": {
    "title": "My account"
  },
  "projectPortfoliosPage": {
    "title": "Portfolios",
    "average": "avr",
    "labels": {
      "projectName": "Project name",
      "dates": "Dates",
      "startDate": "Start",
      "endDate": "End",
      "status": "Status",
      "avgScore": "Strat. score",
      "score": "Strat. score",
      "weather": "Weather",
      "activityMonitoring": {
        "title": "Activity monitoring",
        "done": "Done",
        "delayed": "Delayed",
        "opened": "Opened"
      },
      "workload": {
        "title": "Work",
        "allocatedTime": "Allocated",
        "spentTime": "Spent",
        "remainingWork": "Remaining",
        "remainingWorkShort": "TbD"
      },
      "budget": {
        "title": "Budget",
        "plannedBudget": "Planned",
        "realCosts": "Real costs",
        "acquiredValue": "Acquired"
      }
    },
    "contextualMenu": {
      "projectDetails": "Project details",
      "projectStatus": "Handle status",
      "createProjectModel": "Create a template",
      "strategicImpact": "Strategical impact",
      "move": "Move",
      "remove": "Remove"
    },
    "filterPlaceholder": "Any projects",
    "createProjectPortfolio": "Portfolio",
    "editProjectPortfolio": "Edit",
    "removeProjectPortfolio": "Remove"
  },
  "statusCreationForm": {
    "namePlaceholder": "Status name*",
    "label": "Inclure un % de complétion",
    "warning": "*Veuillez saisir une valeur entre 0 et 99%",
    "addStatus": "New status",
    "submit": "Create"
  },
  "removeResourceGroup": {
    "title": "Are you sure you want to delete this resource group?",
    "group": "The group",
    "removal": "will be permanently deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeTask": {
    "title": "Are you sure you want to delete this task ?",
    "warning": "The task will be permanently deleted",
    "group": "The task",
    "removal": "will be permanently deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeProjectPortfolio": {
    "title": "Are you sure you want to delete this portfolio ?",
    "group": "The portfolio",
    "removal": "will be deleted from your Planzone. The projects will however remain preserved.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeIdentityProvider": {
    "title": "Are you sure you want to delete this SSO ?",
    "message": "this SSO will be permanently deleted.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeProjectFromPortfolio": {
    "title": "Are you sure you want to remove this project from the portfolio ?",
    "confirmation": "The project {{- project}} will be remove from the portfolio {{- portfolio}}.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeEvent": {
    "title": "Are you sure you want to delete this event ?",
    "group": "The event",
    "removal": "will be permanently deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeCostProfile": {
    "title": "Remove cost profile",
    "message": "Are you sure you want to delete the « {{- name}} » cost profile?",
    "hour": "hour",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeCost": {
    "title": "Remove cost",
    "message": "Are you sure you want to delete this cost?",
    "hour": "hour",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeFolder": {
    "title": "Remove a folder",
    "message": "Are you sure you want to delete the « {{folderName}} » folder ?",
    "warning": "This folder and all its documents will be permanently deleted.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeDocument": {
    "title": "Remove a document",
    "message": "Are you sure you want to delete the « {{documentName}} » document ?",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeProjectReport": {
    "title": "Are you sure you want to delete this report ?",
    "group": "The report",
    "removal": "will be permanently deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeMilestone": {
    "title": "Are you sure you want to delete this milestone ?",
    "group": "The milestone",
    "removal": "will be permanently deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeProject": {
    "title": "Are you sure you want to delete this project ?",
    "projectModelTitle": "Are you sure you want to delete this project template ?",
    "group": "This project and it's",
    "projectModelGroup": "This project template and it's",
    "singleGroup": "This project and it's",
    "projectModelSingleGroup": "This project template and it's",
    "one": "one",
    "elements": "elements",
    "element": "element",
    "noElements": "This project will be permanently deleted",
    "projectModelNoElements": "This project template will be permanently deleted",
    "removal": "will be permanently deleted",
    "removeOneElement": "This project will be deleted.",
    "projectModelRemoveOneElement": "This project template will be deleted.",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "removeList": {
    "title": "Are you sure you want to delete this list ?",
    "singular": "This element will be removed",
    "plural": "This element and its sub-elements will be deleted",
    "confirm": "Remove",
    "cancel": "Cancel"
  },
  "taskPage": {
    "title": "Task details",
    "allocations": {
      "placeholder": "There are no resources allocated to this task."
    }
  },
  "milestonePage": {
    "title": "Milestone details"
  },
  "listPage": {
    "title": "List details"
  },
  "planzoneMaterialResourceAddition": {
    "title": "Create a material resource",
    "confirm": "Create",
    "cancel": "Cancel"
  },
  "projectMaterialResourceAddition": {
    "title": "Create a material resource",
    "confirm": "Create",
    "cancel": "Cancel"
  },
  "planzoneVirtualResourceAddition": {
    "title": "Create a virtual resource",
    "addResource": "Add another virtual member",
    "confirm": "Create",
    "cancel": "Cancel"
  },
  "projectVirtualResourceAddition": {
    "title": "Create a virtual resource",
    "addResource": "Add another virtual member",
    "confirm": "Create",
    "cancel": "Cancel"
  },
  "materialResourceForm": {
    "nameTitle": "Name the resource",
    "namePlaceholder": "Resource1..",
    "roleTitle": "Role",
    "rolePlaceholder": "Role",
    "descriptionTitle": "Description (optional)"
  },
  "virtualResourceForm": {
    "nameTitle": "Name the resource",
    "namePlaceholder": "Resource1..",
    "roleTitle": "Role (optional)",
    "rolePlaceholder": "Role",
    "professionTitle": "Profession",
    "professionPlaceholder": "Resource",
    "descriptionTitle": "Description (optional)"
  },
  "removeResourceFromProject": {
    "title": "Remove a member from the project",
    "warning": "You are about to remove a team member.",
    "transfer": "Transfer this user's assignments to someone else first",
    "collaborator": "Select a collaborator",
    "warningTimeRecord": "WARNING: Removing a user will permanently delete all time records logged on this project. If this user has recorded time that needs to be retained, please disable their access instead of removing them.\nThis action cannot be undone.",
    "selectAllTasks": "Select all tasks",
    "noTasks": "No tasks available",
    "cancel": "Cancel",
    "confirm": "Remove"
  },
  "transferProjectResourceAllocations": {
    "title": "Transfer Allocations",
    "warning": "Transfer allocations from one resource to another in this project.",
    "from": "From resource:",
    "to": "To resource:",
    "selectDestination": "Select a destination resource",
    "selectAllTasks": "Select all tasks",
    "noTasks": "No tasks allocated to this resource",
    "cancel": "Cancel",
    "confirm": "Transfer"
  },
  "kanban": {
    "title": "Kanban",
    "filters": {
      "status": {
        "title": "Show :",
        "all": "All",
        "done": "Work done",
        "started": "Tasks started",
        "planned": "Not started tasks"
      },
      "sortFilter": {
        "title": "Sort by :",
        "filterOne": "No sorting (default)",
        "filterTwo": "Start date",
        "filterThree": "Deadline",
        "filterFour": "Date of completion",
        "filterFive": "Creation date",
        "filterSix": "Last edit"
      },
      "resourceFilter": {
        "all": "Everyone",
        "me": "(me)",
        "users": "Users",
        "groups": "Groups",
        "tags": "Resource tag"
      }
    },
    "taskCreation": {
      "addTask": "New task",
      "namePlaceholder": "Name",
      "submit": "Save"
    },
    "task": {
      "startDate": "Start",
      "endDate": "End"
    }
  },
  "addMemberFromPlanzone": {
    "location": "From Planzone"
  },
  "addPlanzoneResourceToProject": {
    "title": "Add a planzone resource to the project",
    "description": "Add users from the list of planzone members",
    "input_one": "Select one or more resources",
    "removeSelectedResources": "Delete all",
    "clear": "Clear",
    "input_two": "Select a role",
    "send": "add",
    "cancel": "cancel",
    "placeholder": "Select a resource"
  },
  "addPlanzoneResourceToProjects": {
    "title": "Add a resource from Planzone to multiple projects",
    "description": "Add users from the Planzone member list",
    "inputProject": "Select one or more projects",
    "inputRole": "Select a role",
    "submit": "Save",
    "cancel": "Cancel",
    "placeholder": "Select projects"
  },

  "removeResourceFromPlanZone": {
    "title": "remove resource from planzone",
    "description": "You are about to delete a resource from the Planzone",
    "transfer": "Forward this user's assignments to someone else first.",
    "cancel": "Cancel",
    "confirm": "Remove",
    "remove": "Delete"
  },
  "unavailabilityRemoval": {
    "title": "Remove unavailability",
    "description": "You are about to remove an unavailability",
    "cancel": "Cancel",
    "confirm": "Remove",
    "remove": "Delete"
  },
  "removeComment": {
    "title": "Remove a comment",
    "description": "Are you sure you want to remove this comment",
    "cancel": "Cancel",
    "confirm": "Remove"
  },
  "comment": {
    "placeholder": "Add a comment...",
    "submit": "Send",
    "reply": "Reply"
  },
  "removeDiscussion": {
    "title": "Remove a discussion",
    "description": "Are you sure you want to remove this discussion",
    "cancel": "Cancel",
    "confirm": "Remove"
  },
  "removeTaskStatus": {
    "title": "Remove a status",
    "warningTasks": "The status you are about to delete contains tasks. Select the status to transfer them to.",
    "warningNoTasks": "Are you sure you want to delete this task status ?",
    "placeholder": "Choose a status",
    "noTasksPlaceholder": "0 task(s)",
    "cancel": "Cancel",
    "confirmTasks": "Delete and transfer tasks",
    "confirmNoTasks": "Delete"
  },
  "projectTaskStatuses": {
    "title": "manage project task statuses",
    "activeStatus": "active status",
    "closeStatus": "statutes closed",
    "addStatus": "New statut"
  },
  "preferences": {
    "profileTitle": "My profile",
    "preferencesTitle": "My preferences",
    "securityTitle": "Security",
    "notificationsTitle": "Mail alert preferences",
    "activityReportTitle": "Frequency of activity reports",
    "calendarTitle": "Work schedule",
    "calendarHolidays": {
      "inputPersonalCalendarHolidays": "Choose a holiday calendar",
      "description": "This module allows you to set the default availability parameters for your resources"
    },
    "languageSelectionForm": {
      "title": "Planzone language",
      "languages": ["fr", "en"]
    },
    "profile": {
      "name": "Nom",
      "email": "Adresse email",
      "tags": "Tags resource"
    },
    "mfa": {
      "title": "Activate multi factor authentication"
    },
    "notifications": {
      "delayedTask": {
        "title": "A task to which you have been assigned is running late"
      },
      "addedToTask": {
        "title": "You have been assigned a task"
      },
      "mentionInComment": {
        "title": "You have been mentioned in a comment"
      },
      "replyToComment": {
        "title": "Someone replied to your comment"
      },
      "addedToProject": {
        "title": "You have been assigned to a project"
      },
      "projectStatusChanged": {
        "title": "A project status has changed"
      }
    },
    "activityReport": {
      "title": "How often would you like to receive this report?",
      "explanation": "The activity Report is a summary of your tasks in <span style=\"color:#db5f63;\">delay</span> and <span style=\"color:#4892cc;\">upcoming</span>.",
      "sendReport": "Send now",
      "options": {
        "never": "Never",
        "everyLastDayOfMonth": "The last day of each month",
        "everyFifteenthDayOfMonth": "The 15th of each month",
        "everySecondDayOfMonth": "The second day of each month",
        "everyFirstDayOfMonth": "The first day of each month",
        "everySaturday": "Saturday",
        "everyFriday": "Friday",
        "everyThursday": "Thursday",
        "everyWednesday": "Wednesday",
        "everyTuesday": "Tuesday",
        "everyMonday": "Monday",
        "everyTwoDays": "Every 2 days",
        "everyDay": "Every day"
      }
    },
    "changePassword": {
      "title": "Password",
      "submit": "Save",
      "currentPassword": "Current password",
      "placeholder": "12 characters, at least 1 uppercase and 1 special character",
      "errors": {
        "wrongPassword": "Your current password confirmation is wrong.",
        "tooShort": "The password must be at least 12 characters long.",
        "specialCharsOrNum": "The password must contain at least one number or special character.",
        "upper": "The password must contain at least one capital letter.",
        "mismatchedConfirmation": "The confirmation of your password does not match your password."
      }
    },
    "timeZoneForm": {
      "title": "Time zone",
      "placeholder": "Select a time zone",
      "timeZones": [
        "Europe/Andorra",
        "Asia/Dubai",
        "Asia/Kabul",
        "Europe/Tirane",
        "Asia/Yerevan",
        "Antarctica/Casey",
        "Antarctica/Davis",
        "Antarctica/DumontDUrville",
        "Antarctica/Mawson",
        "Antarctica/Palmer",
        "Antarctica/Rothera",
        "Antarctica/Syowa",
        "Antarctica/Troll",
        "Antarctica/Vostok",
        "America/Argentina/Buenos_Aires",
        "America/Argentina/Cordoba",
        "America/Argentina/Salta",
        "America/Argentina/Jujuy",
        "America/Argentina/Tucuman",
        "America/Argentina/Catamarca",
        "America/Argentina/La_Rioja",
        "America/Argentina/San_Juan",
        "America/Argentina/Mendoza",
        "America/Argentina/San_Luis",
        "America/Argentina/Rio_Gallegos",
        "America/Argentina/Ushuaia",
        "Pacific/Pago_Pago",
        "Europe/Vienna",
        "Australia/Lord_Howe",
        "Antarctica/Macquarie",
        "Australia/Hobart",
        "Australia/Currie",
        "Australia/Melbourne",
        "Australia/Sydney",
        "Australia/Broken_Hill",
        "Australia/Brisbane",
        "Australia/Lindeman",
        "Australia/Adelaide",
        "Australia/Darwin",
        "Australia/Perth",
        "Australia/Eucla",
        "Asia/Baku",
        "America/Barbados",
        "Asia/Dhaka",
        "Europe/Brussels",
        "Europe/Sofia",
        "Atlantic/Bermuda",
        "Asia/Brunei",
        "America/La_Paz",
        "America/Noronha",
        "America/Belem",
        "America/Fortaleza",
        "America/Recife",
        "America/Araguaina",
        "America/Maceio",
        "America/Bahia",
        "America/Sao_Paulo",
        "America/Campo_Grande",
        "America/Cuiaba",
        "America/Santarem",
        "America/Porto_Velho",
        "America/Boa_Vista",
        "America/Manaus",
        "America/Eirunepe",
        "America/Rio_Branco",
        "America/Nassau",
        "Asia/Thimphu",
        "Europe/Minsk",
        "America/Belize",
        "America/St_Johns",
        "America/Halifax",
        "America/Glace_Bay",
        "America/Moncton",
        "America/Goose_Bay",
        "America/Blanc-Sablon",
        "America/Toronto",
        "America/Nipigon",
        "America/Thunder_Bay",
        "America/Iqaluit",
        "America/Pangnirtung",
        "America/Atikokan",
        "America/Winnipeg",
        "America/Rainy_River",
        "America/Resolute",
        "America/Rankin_Inlet",
        "America/Regina",
        "America/Swift_Current",
        "America/Edmonton",
        "America/Cambridge_Bay",
        "America/Yellowknife",
        "America/Inuvik",
        "America/Creston",
        "America/Dawson_Creek",
        "America/Fort_Nelson",
        "America/Vancouver",
        "America/Whitehorse",
        "America/Dawson",
        "Indian/Cocos",
        "Europe/Zurich",
        "Africa/Abidjan",
        "Pacific/Rarotonga",
        "America/Santiago",
        "America/Punta_Arenas",
        "Pacific/Easter",
        "Asia/Shanghai",
        "Asia/Urumqi",
        "America/Bogota",
        "America/Costa_Rica",
        "America/Havana",
        "Atlantic/Cape_Verde",
        "America/Curacao",
        "Indian/Christmas",
        "Asia/Nicosia",
        "Asia/Famagusta",
        "Europe/Prague",
        "Europe/Berlin",
        "Europe/Copenhagen",
        "America/Santo_Domingo",
        "Africa/Algiers",
        "America/Guayaquil",
        "Pacific/Galapagos",
        "Europe/Tallinn",
        "Africa/Cairo",
        "Africa/El_Aaiun",
        "Europe/Madrid",
        "Africa/Ceuta",
        "Atlantic/Canary",
        "Europe/Helsinki",
        "Pacific/Fiji",
        "Atlantic/Stanley",
        "Pacific/Chuuk",
        "Pacific/Pohnpei",
        "Pacific/Kosrae",
        "Atlantic/Faroe",
        "Europe/Paris",
        "Europe/London",
        "Asia/Tbilisi",
        "America/Cayenne",
        "Africa/Accra",
        "Europe/Gibraltar",
        "America/Godthab",
        "America/Danmarkshavn",
        "America/Scoresbysund",
        "America/Thule",
        "Europe/Athens",
        "Atlantic/South_Georgia",
        "America/Guatemala",
        "Pacific/Guam",
        "Africa/Bissau",
        "America/Guyana",
        "Asia/Hong_Kong",
        "America/Tegucigalpa",
        "America/Port-au-Prince",
        "Europe/Budapest",
        "Asia/Jakarta",
        "Asia/Pontianak",
        "Asia/Makassar",
        "Asia/Jayapura",
        "Europe/Dublin",
        "Asia/Jerusalem",
        "Asia/Kolkata",
        "Indian/Chagos",
        "Asia/Baghdad",
        "Asia/Tehran",
        "Atlantic/Reykjavik",
        "Europe/Rome",
        "America/Jamaica",
        "Asia/Amman",
        "Asia/Tokyo",
        "Africa/Nairobi",
        "Asia/Bishkek",
        "Pacific/Tarawa",
        "Pacific/Enderbury",
        "Pacific/Kiritimati",
        "Asia/Pyongyang",
        "Asia/Seoul",
        "Asia/Almaty",
        "Asia/Qyzylorda",
        "Asia/Qostanay",
        "Asia/Aqtobe",
        "Asia/Aqtau",
        "Asia/Atyrau",
        "Asia/Oral",
        "Asia/Beirut",
        "Asia/Colombo",
        "Africa/Monrovia",
        "Europe/Vilnius",
        "Europe/Luxembourg",
        "Europe/Riga",
        "Africa/Tripoli",
        "Africa/Casablanca",
        "Europe/Monaco",
        "Europe/Chisinau",
        "Pacific/Majuro",
        "Pacific/Kwajalein",
        "Asia/Yangon",
        "Asia/Ulaanbaatar",
        "Asia/Hovd",
        "Asia/Choibalsan",
        "Asia/Macau",
        "America/Martinique",
        "Europe/Malta",
        "Indian/Mauritius",
        "Indian/Maldives",
        "America/Mexico_City",
        "America/Cancun",
        "America/Merida",
        "America/Monterrey",
        "America/Matamoros",
        "America/Mazatlan",
        "America/Chihuahua",
        "America/Ojinaga",
        "America/Hermosillo",
        "America/Tijuana",
        "America/Bahia_Banderas",
        "Asia/Kuala_Lumpur",
        "Asia/Kuching",
        "Africa/Maputo",
        "Africa/Windhoek",
        "Pacific/Noumea",
        "Pacific/Norfolk",
        "Africa/Lagos",
        "America/Managua",
        "Europe/Amsterdam",
        "Europe/Oslo",
        "Asia/Kathmandu",
        "Pacific/Nauru",
        "Pacific/Niue",
        "Pacific/Auckland",
        "Pacific/Chatham",
        "America/Panama",
        "America/Lima",
        "Pacific/Tahiti",
        "Pacific/Marquesas",
        "Pacific/Gambier",
        "Pacific/Port_Moresby",
        "Pacific/Bougainville",
        "Asia/Manila",
        "Asia/Karachi",
        "Europe/Warsaw",
        "America/Miquelon",
        "Pacific/Pitcairn",
        "America/Puerto_Rico",
        "Asia/Gaza",
        "Asia/Hebron",
        "Europe/Lisbon",
        "Atlantic/Madeira",
        "Atlantic/Azores",
        "Pacific/Palau",
        "America/Asuncion",
        "Asia/Qatar",
        "Indian/Reunion",
        "Europe/Bucharest",
        "Europe/Belgrade",
        "Europe/Kaliningrad",
        "Europe/Moscow",
        "Europe/Simferopol",
        "Europe/Kirov",
        "Europe/Astrakhan",
        "Europe/Volgograd",
        "Europe/Saratov",
        "Europe/Ulyanovsk",
        "Europe/Samara",
        "Asia/Yekaterinburg",
        "Asia/Omsk",
        "Asia/Novosibirsk",
        "Asia/Barnaul",
        "Asia/Tomsk",
        "Asia/Novokuznetsk",
        "Asia/Krasnoyarsk",
        "Asia/Irkutsk",
        "Asia/Chita",
        "Asia/Yakutsk",
        "Asia/Khandyga",
        "Asia/Vladivostok",
        "Asia/Ust-Nera",
        "Asia/Magadan",
        "Asia/Sakhalin",
        "Asia/Srednekolymsk",
        "Asia/Kamchatka",
        "Asia/Anadyr",
        "Asia/Riyadh",
        "Pacific/Guadalcanal",
        "Indian/Mahe",
        "Africa/Khartoum",
        "Europe/Stockholm",
        "Asia/Singapore",
        "America/Paramaribo",
        "Africa/Juba",
        "Africa/Sao_Tome",
        "America/El_Salvador",
        "Asia/Damascus",
        "America/Grand_Turk",
        "Africa/Ndjamena",
        "Indian/Kerguelen",
        "Asia/Bangkok",
        "Asia/Dushanbe",
        "Pacific/Fakaofo",
        "Asia/Dili",
        "Asia/Ashgabat",
        "Africa/Tunis",
        "Pacific/Tongatapu",
        "Europe/Istanbul",
        "America/Port_of_Spain",
        "Pacific/Funafuti",
        "Asia/Taipei",
        "Europe/Kiev",
        "Europe/Uzhgorod",
        "Europe/Zaporozhye",
        "Pacific/Wake",
        "America/New_York",
        "America/Detroit",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Indiana/Indianapolis",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Indiana/Marengo",
        "America/Indiana/Petersburg",
        "America/Indiana/Vevay",
        "America/Chicago",
        "America/Indiana/Tell_City",
        "America/Indiana/Knox",
        "America/Menominee",
        "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem",
        "America/North_Dakota/Beulah",
        "America/Denver",
        "America/Boise",
        "America/Phoenix",
        "America/Los_Angeles",
        "America/Anchorage",
        "America/Juneau",
        "America/Sitka",
        "America/Metlakatla",
        "America/Yakutat",
        "America/Nome",
        "America/Adak",
        "Pacific/Honolulu",
        "America/Montevideo",
        "Asia/Samarkand",
        "Asia/Tashkent",
        "America/Caracas",
        "Asia/Ho_Chi_Minh",
        "Pacific/Efate",
        "Pacific/Wallis",
        "Pacific/Apia",
        "Africa/Johannesburg"
      ]
    },
    "calendarStartDateForm": {
      "title": "Weekly calendar",
      "placeholder": "Select a date",
      "dates": [
        {
          "id": "monday",
          "name": "Monday"
        },
        {
          "id": "tuesday",
          "name": "Tuesday"
        },
        {
          "id": "wednesday",
          "name": "Wednesday"
        },
        {
          "id": "thursday",
          "name": "Thursday"
        },
        {
          "id": "friday",
          "name": "Friday"
        },
        {
          "id": "saturday",
          "name": "Saturday"
        },
        {
          "id": "sunday",
          "name": "Sunday"
        }
      ]
    },
    "timeFormatForm": {
      "title": "Preferred time format",
      "placeholder": "Select a format"
    },
    "dateFormatForm": {
      "title": "Preferred date format",
      "placeholder": "Select a format"
    },
    "taskCompletionBehaviorForm": {
      "title": "When I complete a task",
      "placeholder": "Select a behavior",
      "behaviors": [
        {
          "id": "useCurrentDate",
          "name": "Always use today's date as the completion date"
        }
      ]
    },
    "defaultUserFilterForm": {
      "title": "By default, sort users by",
      "placeholder": "Select a filter",
      "filters": [
        {
          "id": "firstName",
          "name": "First name"
        },
        {
          "id": "lastName",
          "name": "Last name"
        }
      ]
    }
  },
  "calendar": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "monday": "M",
    "tuesday": "T",
    "wednesday": "W",
    "thursday": "T",
    "friday": "F",
    "saturday": "S",
    "sunday": "S",
    "inputLabel": "Year",
    "weekends": "Week-Ends",
    "holidays": "Holidays",
    "unavailability": "Unavailability",
    "clear": "Clear",
    "today": "Today",
    "creationMenu": {
      "button": "Create",
      "createUnavailability": "Unavailability",
      "createTask": "Task",
      "createMilestone": "Milestone",
      "createEvent": "Event",
      "selectProject": "Select a project",
      "list": "In:",
      "start": "Start:",
      "end": "End:",
      "reason": "Reason:",
      "participants": "Participants:",
      "customFields": "Custom fields:",
      "description": "Description:",
      "descriptionPlaceholder": "Add a description",
      "submit": "Create"
    }
  },
  "gantt": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "inputLabel": "Year",
    "details": {
      "views": {
        "dates": "Dates",
        "progress": "%",
        "timeSpent": "Hours"
      },
      "title": "Details",
      "startDate": "Start",
      "endDate": "End",
      "duration": "Duration",
      "estimated": "Estimated",
      "allocated": "Allocated",
      "spent": "Spent",
      "progress": "% done",
      "name": "Name"
    },
    "tasksContextualMenu": {
      "edit": "Edit",
      "move": "Move",
      "duplicate": "Duplicate",
      "remove": "Delete"
    },
    "resizePopup": {
      "startDate": "Start date",
      "endDate": "End date"
    },
    "workLoadsToggle": "Workloads",
    "delayToggle": "Delay",
    "derivationToggle": "Derivation"
  },
  "workLoads": {
    "title": "Workloads",
    "labels": {
      "name": "Name",
      "capacity": "Capacity",
      "groups": "Group",
      "function": "Function"
    }
  },
  "timeRecordsListingConfiguration": {
    "title": "Columns configuration",
    "name": "Configuration profile name",
    "roles": "Configure for",
    "columns": "Display",
    "columnNames": {
      "date": "Date",
      "resourceTask": "Resource / Task",
      "project": "Project",
      "timeSpent": "Time",
      "validation": "Validation"
    },
    "addColumn": "Add",
    "addProfile": "Add configuration",
    "cancel": "Cancel",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit"
  },
  "weekTimeRecords": {
    "title": "Week time records",
    "empty": "No time record this week",
    "columns": {
      "date": "Date",
      "resourceTask": "Resource / Task",
      "project": "Project",
      "timeSpent": "Time",
      "validation": "Validation"
    },
    "validated": "Validated",
    "toValidate": "To validate",
    "edit": "Edit time record",
    "remove": "Delete time record"
  },
  "timeRecordRemoval": {
    "title": "Delete time record",
    "message": "Do you really want to delete this time record?",
    "cancel": "Cancel",
    "confirm": "Delete"
  },
  "timeRecordCriteria": {
    "title": "Time record",
    "task": "Task",
    "resource": "Resource",
    "date": "Date",
    "criteria": "Time record criteria",
    "open": "Edit time record",
    "timeSpent": "Time spent (h)",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close"
  },
  "timeSheet": {
    "title": "Time recording",
    "button": "+ Add",
    "estimatedTime": "Estimated",
    "allocatedTime": "Allocated",
    "spentTime": "Spent",
    "spentTimeInWeek": "Spent (week)",
    "remainingTime": "Remaining",
    "percent": "% done",
    "week": "Week",
    "weekSelector": "Week from {{-from}} to {{-to}}",
    "moveToToday": "Go to today",
    "workDoneToggle": "Work done",
    "deactivatedProjectsToggle": "Deactivated ",
    "deactivatedResourcesToggle": "Resources deactivated",
    "removedResourcesToggle": "Resources removed from project",
    "removedProjectsToggle": "Removed projects",
    "includeProjectsWithoutSpentTimeToggle": "Integrated time spent = 0",
    "includeProjectsWithoutSpentTimeInWeekToggle": "Integrated time spent (week) = 0",
    "includeProjectsWithoutNonIntegratedSpentTimeInWeekToggle": "Time spent (week) = 0",
    "detailsToggle": "Details",
    "lockDate": "Lock",
    "tutorial": {
      "title": "You have no allocation for this project.",
      "action": "Allocate a resource to a task",
      "message": "to display the project's time tracking."
    },
    "filters": {
      "title": "Filter by :",
      "default": "No filter",
      "allProjects": "All projects",
      "allResources": "Everyone",
      "and": "And by"
    }
  },
  "quickListCreation": {
    "add": "Add a list",
    "placeholder": "Name the new list",
    "cancel": "Cancel"
  },
  "projectReportSubmission": {
    "title": "Make a report",
    "nameTitle": "Name of the report",
    "namePlaceholder": "Ex: Report 23/03/2022",
    "defaultTitle": "Report of {{- date }}",
    "submit": "Submit",
    "templateSelect": "Report template",
    "templateSelectPlaceholder": "Select a template"
  },
  "projectReport": {
    "title": "Report",
    "submissionDate": "Submitted on",
    "by": "by",
    "submit": "Edit",
    "remove": "Delete",
    "duplicate": "Duplicate",
    "downloadPdf": "Download"
  },
  "milestoneCompletion": {
    "title": "Mark this milestone as completed",
    "subTitle": "On what date would you like to mark this milestone as completed?",
    "today": "Today",
    "endDate": "Planned end date",
    "anotherDate": "Another date",
    "placeholder": "Choose a date",
    "cancel": "Cancel",
    "submit": "Confirm"
  },
  "taskCompletion": {
    "title": "Mark this task as completed",
    "subTitle": "The task involves multiple resources. Would you prefer to complete your allocation or take on the entire task?",
    "completionDate": "On what date would you like to mark this task as completed?",
    "today": "Today",
    "endDate": "Planned end date",
    "anotherDate": "Another date",
    "placeholder": "Choose a date",
    "markOnlyMyAllocation": "Mark only my allocation as 100%",
    "markEntireTaskCompleted": "Mark the entire task as completed",
    "cancel": "Cancel",
    "submit": "Confirm"
  },
  "projectExternalLinks": {
    "title": "External practical links",
    "namePlaceholder": "Name",
    "urlPlaceholder": "Link"
  },
  "attachments": {
    "files": "Files",
    "noFile": "No file",
    "dropFileHere": "Drop a file here.",
    "add": "Add"
  },
  "unavailabilityReasons": {
    "holidays": "Holidays",
    "sickLeave": "Sick Leaves",
    "other": "Other"
  },
  "unavailability": {
    "unavailability": "Unavailability",
    "creation": {
      "title": "Create an unavailability",
      "editTitle": "Edit an unavailability",
      "name": "Name of the unavailability",
      "namePlaceholder": "Name the unavailability",
      "for": "For",
      "forPlaceholder": "Select",
      "me": "Me",
      "reason": "Reason",
      "reasonPlaceholder": "Select a reason",
      "startDateTitle": "Start:",
      "startDatePlaceholder": "Select a date",
      "endDateTitle": "End:",
      "endDatePlaceholder": "Select a date",
      "fullDay": "All day",
      "partialDay": "Partial day",
      "durationHour": "From:",
      "durationDay": "On:",
      "partialEndTime": "To:",
      "cancel": "Cancel",
      "submit": "Create",
      "edit": "Edit",
      "remove": "Remove"
    }
  },
  "appNotifications": {
    "exportBiRun": {
      "success": "Your BI export is completed, files are available in documents",
      "partial": "Your BI export is partially completed, some files could not be generated",
      "failure": "Your BI export failed",
      "requestFailure": "The BI export could not be started",
      "retrieveFailure": "Unable to retrieve the BI export status"
    },
    "close": "Close",
    "adjustWorkload": {
      "success": "Your workload entry has been successfully saved",
      "failure": "The workload entry could not be saved",
      "forbidden": "You do not have permission to adjust this resource's workload",
      "notFound": "This resource or project could not be found"
    },
    "adjustCapacity": {
      "success": "Your capacity adjustment has been successfully saved",
      "failure": "The capacity adjustment could not be saved",
      "forbidden": "You do not have permission to adjust this resource's capacity",
      "notFound": "This resource could not be found"
    },
    "authenticate": {
      "invalidCredentials": "Your credentials did not match any account",
      "unExpectedError": "An unexpected error occurred"
    },
    "changePassword": {
      "success": "Your password has been successfully edited",
      "failure": "Your password could not be edited"
    },
    "fillAccount": {
      "success": "Your account has been successfully validated",
      "failure": "Your account could not be validated",
      "alreadyConfirmed": "Vous avez déja confirmé votre inscription"
    },
    "startDiscussion": {
      "success": "Your thread was successfully created",
      "failure": "Your thread could not be created"
    },
    "retrieveZones": {
      "planzoneNotFound": "The provided planzone was not found",
      "unExpectedError": "An unexpected error occurred"
    },
    "retrieveZone": {
      "zoneNotFound": "The provided zone was not found",
      "unExpectedError": "An unexpected error occurred"
    },
    "retrieveEvent": {
      "notFound": "The event does not exist or has been deleted.",
      "failure": "An unexpected error occurred"
    },
    "retrieveMilestone": {
      "notFound": "The milestone does not exist or has been deleted.",
      "failure": "An unexpected error occurred"
    },
    "retrieveTask": {
      "notFound": "The task does not exist or has been deleted.",
      "failure": "An unexpected error occurred"
    },
    "retrieveList": {
      "notFound": "The list does not exist, has been deleted.",
      "failure": "An unexpected error occurred"
    },
    "removeZone": {
      "success": "Your zone was successfully removed",
      "failure": "An unexpected error occurred"
    },
    "removeEvent": {
      "notFound": "The event does not exist or has been deleted",
      "success": "Your zone was successfully removed",
      "failure": "An unexpected error occurred"
    },
    "transferProjects": {
      "success": "Your projects were successfully transferred",
      "failure": "An unexpected error occurred"
    },
    "createZone": {
      "success": "Your zone was successfully created",
      "unExpectedError": "An unexpected error occurred",
      "invalidName": "You must provide a name for the zone",
      "duplicateZone": "You cannot have two zone with the same name"
    },
    "editZone": {
      "success": "Your zone was successfully edited",
      "unExpectedError": "An unexpected error occurred",
      "invalidName": "You must provide a name for the zone",
      "duplicateZone": "You cannot have two zone with the same name"
    },
    "editTask": {
      "emptyName": "You must provide a name for your task",
      "duplicateName": "This task name is already in use",
      "invalidDateRange": "The task's start date cannot be later than its end date and vice versa",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists",
      "startDateOutOfBoundProject": "The start date of this element cannot be earlier than the project start date.",
      "listNotFound": "The parent list does not exist",
      "success": "Your task was successfully edited",
      "failure": "Your task could not be edited",
      "unExpectedError": "An unexpected error occurred"
    },
    "editEvent": {
      "emptyName": "You must provide a name for your event",
      "duplicateName": "This event name is already in use",
      "invalidDateRange": "The event's start date cannot be later than its end date, and vice versa",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists",
      "notFound": "The event does not exist or has been deleted",
      "listNotFound": "The parent list does not exist",
      "success": "Your event was successfully edited",
      "failure": "Your event could not be edited",
      "unExpectedError": "An unexpected error occurred"
    },
    "editList": {
      "emptyName": "You must provide a name for your list.",
      "duplicateName": "This list name is already in use. Please choose another.",
      "invalidDateRange": "The list's start date cannot be later than its end date, and vice versa. Please adjust the dates.",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists. Please adjust the start date.",
      "startDateOutOfBoundProject": "The start date of this element cannot be earlier than the project start date.",
      "listNotFound": "The parent list associated with this list does not exist. Please select a valid list.",
      "success": "Your list was successfully edited.",
      "failure": "Your list could not be edited. Please check the provided information.",
      "unExpectedError": "An unexpected error occurred."
    },
    "createProject": {
      "success": "Your project was successfully created",
      "failure": "Your project could not be created"
    },
    "createAccount": {
      "success": "Your account was successfully created",
      "failure": "Your account could not be created"
    },
    "confirmAccountCreation": {
      "invalidPassword": "Your password is invalid",
      "invalidPasswordConfirmation": "Your passwords do not match",
      "invalidUsername": "Your user name is invalid",
      "invalidCompany": "Your company name is invalid",
      "missingAddress": "You must provide an address with your planzone",
      "isPlanzoneNameInvalid": "Your planzone name is invalid",
      "isPlanzoneDomainInvalid": "Your planzone domain is invalid",
      "unExpectedError": "An unexpected error occurred",
      "success": "Your account was successfully created, you can now log in"
    },
    "createTaskStatus": {
      "success": "Your status was successfully created",
      "failure": "Your status could not be created"
    },
    "editTaskStatus": {
      "success": "Your status was successfully edited",
      "failure": "Your status could not be edited"
    },
    "editProjectWeatherReport": {
      "success": "Your project's weather report was successfully edited",
      "failure": "Your project's weather report could not be edited"
    },
    "addResourceGroup": {
      "success": "Your group was successfully created",
      "failure": "Your group could not be created"
    },
    "editResourceGroup": {
      "success": "Your group was successfully edited",
      "failure": "Your group could not be edited"
    },
    "editUserPreferences": {
      "success": "Your preferences were successfully edited",
      "failure": "Your preferences could not be edited"
    },
    "createList": {
      "emptyName": "You must provide a name for your list.",
      "duplicateName": "This list name is already in use. Please choose another.",
      "invalidDateRange": "The list's start date cannot be later than its end date, and vice versa. Please adjust the dates.",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists. Please adjust the start date.",
      "listNotFound": "The parent list associated with this list does not exist. Please select a valid list.",
      "success": "Your list was successfully created.",
      "failure": "Your list could not be created. Please check the provided information."
    },
    "createTask": {
      "emptyName": "You must provide a name for your task",
      "duplicateName": "This task name is already in use",
      "invalidDateRange": "The task's start date cannot be later than its end date and vice versa",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists",
      "listNotFound": "The parent list does not exist",
      "success": "Your task was successfully created",
      "failure": "Your task could not be created"
    },
    "createEvent": {
      "emptyName": "You must provide a name for your event",
      "duplicateName": "This event name is already in use",
      "invalidDateRange": "The event's start date cannot be later than its end date and vice versa",
      "startDateOutOfBound": "The start date cannot be earlier than that of its parent lists",
      "listNotFound": "The parent list does not exist",
      "success": "Your event was successfully created",
      "failure": "Your event could not be created"
    },
    "removeResourceGroup": {
      "success": "Your group was successfully removed",
      "failure": "Your group could not be removed"
    },
    "removeTask": {
      "notFound": "The task does not exist or has been deleted.",
      "success": "Your task was successfully removed",
      "failure": "Your task could not be removed"
    },
    "removeOrganizationalUnit": {
      "notFound": "The organizational unit does not exist or has already been deleted.",
      "success": "The organizational unit was successfully deleted",
      "failure": "The organizational unit could not be deleted"
    },
    "moveOrganizationalUnit": {
      "cycle": "This unit cannot be moved into one of its own sub-units.",
      "duplicateName": "A unit with the same name already exists in the selected destination.",
      "success": "The organizational unit was successfully moved",
      "failure": "The organizational unit could not be moved"
    },
    "updateOrganizationalUnit": {
      "success": "The organizational unit was successfully updated",
      "failure": "The organizational unit could not be updated"
    },
    "removeMilestone": {
      "notFound": "The milestone does not exist or has been deleted.",
      "success": "Your milestone was successfully removed",
      "failure": "Your milestone could not be removed"
    },
    "removeProject": {
      "success": "Your project was successfully removed",
      "failure": "Your project could not be removed"
    },
    "removeList": {
      "notFound": "The list does not exist or has been deleted.",
      "success": "Your list was successfully removed",
      "failure": "Your list could not be removed"
    },
    "addPlanzoneMaterialResource": {
      "success": "Your resource was successfully created",
      "failure": "Your resource could not be created"
    },
    "addPlanzoneVirtualResource": {
      "success": "Your resource was successfully created",
      "failure": "Your resource could not be created"
    },
    "addProjectMaterialResource": {
      "success": "Your resource was successfully created",
      "failure": "Your resource could not be created"
    },
    "addProjectVirtualResource": {
      "success": "Your resource was successfully created",
      "failure": "Your resource could not be created"
    },
    "allocateResources": {
      "duplicateAllocation": "The resource has already been allocated to the task.",
      "success": "Your resources were successfully allocated",
      "failure": "Your resources could not be allocated"
    },
    "addResourceToResourceGroup": {
      "success": "Your resource was successfully added to this group",
      "failure": "Your resource could not be added to this group"
    },
    "removeResourceFromResourceGroup": {
      "success": "Your resource was successfully removed from this group",
      "failure": "Your resource could not be removed from this group"
    },
    "removeResourceFromProject": {
      "success": "This team member was successfully removed",
      "failure": "This team member could not be removed"
    },
    "removeResourceFromPlanzone": {
      "success": "Your resource was successfully removed",
      "failure": "Impossible to delete this resource"
    },
    "editAllocation": {
      "success": "Your allocation was successfully edited",
      "failure": "Your allocation could not be edited"
    },
    "removeAllocation": {
      "notFound": "The allocation does not exist or has been deleted",
      "success": "Your allocation was successfully removed",
      "failure": "Your allocation could not be removed"
    },
    "editMilestone": {
      "emptyName": "You must provide a name for your milestone.",
      "duplicateName": "This milestone name is already in use. Please choose another.",
      "endDateOutOfBound": "The start date cannot be earlier than that of its parent lists. Please adjust the start date.",
      "endDateOutOfBoundProject": "The start date of this element cannot be earlier than the project start date.",
      "listNotFound": "The parent list associated with this Milestone does not exist. Please select a valid list.",
      "success": "Your milestone was successfully modified.",
      "failure": "Your milestone could not be edited.",
      "unExpectedError": "An unexpected error occurred."
    },
    "removeTaskStatus": {
      "success": "Your status was successfully removed",
      "failure": "Your status could not be removed"
    },
    "addPlanzoneResourceToProject": {
      "success": "Your resource was successfully added to your project",
      "failure": "Your resource could not be added to your project"
    },
    "addProjectExternalLink": {
      "success": "Your link was successfully added to your project",
      "failure": "Your link could not be added to your project"
    },
    "assignTag": {
      "success": "Your tag was successfully assigned",
      "failure": "Your tag could not be assigned"
    },
    "changePlanzone": {
      "failure": "Something went wrong"
    },
    "createMilestone": {
      "emptyName": "You must provide a name for your Milestone.",
      "duplicateName": "This Milestone name is already in use. Please choose another.",
      "endDateOutOfBound": "The end date cannot be earlier than that of its parent lists. Please adjust the end date.",
      "listNotFound": "The parent list associated with this Milestone does not exist. Please select a valid list.",
      "success": "Your Milestone was successfully created.",
      "failure": "Your Milestone could not be created. Please check the provided information."
    },
    "createProjectStatus": {
      "success": "Your project status was successfully created",
      "failure": "Your project status could not be created"
    },
    "editPersonalWeeklyCalendar": {
      "success": "Your calendar was successfully edited",
      "failure": "Your calendar could not be edited"
    },
    "editProject": {
      "success": "Your project was successfully edited",
      "failure": "Your project could not be edited"
    },
    "editProjectExternalLink": {
      "success": "Your link was successfully edited",
      "failure": "Your link could not be edited"
    },
    "logOut": {
      "failure": "Something went wrong"
    },
    "markMilestoneAsCompleted": {
      "success": "Your milestone has successfully been marked as completed",
      "failure": "Something went wrong"
    },
    "moveKanbanTask": {
      "failure": "Something went wrong"
    },
    "moveListElement": {
      "failure": "Something went wrong",
      "startDateOutOfBoundProject": "The start date cannot be before the project start date",
      "startDateOutOfBound": "The start date cannot be before the parent list start date",
      "endDateOutOfBoundProject": "The end date cannot be before the project start date",
      "endDateOutOfBound": "The end date cannot be before the parent list start date"
    },
    "removeProjectExternalLink": {
      "success": "Your link was successfully removed",
      "failure": "Your link could not be removed"
    },
    "removeProjectStatus": {
      "success": "Your project status was successfully removed",
      "failure": "Your project status could not be removed"
    },
    "removeTag": {
      "success": "Your tag was successfully removed",
      "failure": "Your tag could not be removed"
    },
    "editProjectReportTemplate": {
      "success": "Your template was successfully edited",
      "failure": "Your template could not be edited"
    },
    "submitProjectReport": {
      "success": "Your report was successfully submitted",
      "failure": "Your report could not be submitted"
    },
    "exportData": {
      "failure": "Your report could not be exported"
    },
    "configureProjectTools": {
      "success": "Your views have been successfully edited",
      "failure": "Your views could not be edited"
    },
    "editResource": {
      "success": "Your resource was successfully edited",
      "failure": "Your resource could not be edited"
    },
    "editProjectResource": {
      "success": "Your project resource was successfully edited",
      "failure": "Your project resource could not be edited"
    },
    "markTaskAsCompleted": {
      "completionDateOutOfBound": "The task completion date cannot be before its start date.",
      "notFound": "The task does not exist or has been deleted",
      "failure": "Your task could not be completed"
    },
    "updatePlanzoneContacts": {
      "success": "Your contacts have been successfully edited",
      "failure": "Your contacts could not be edited"
    },
    "createProjectModelFromProject": {
      "success": "Your project template was successfully created",
      "failure": "Your project template could not be created"
    },
    "createProjectPortfolio": {
      "success": "Votre portefeuille de projet a été créé avec succès",
      "duplicateName": "Your portfolio must have a unique name",
      "emptyName": "Your portfolio must have a name"
    },
    "editProjectPortfolio": {
      "success": "Votre portefeuille de projet a été créé avec succès",
      "duplicateName": "Your portfolio must have a unique name",
      "emptyName": "Your portfolio must have a name"
    },
    "inviteMembers": {
      "failureSingular": "An invitation could not be sent",
      "failurePlural": "{{failedInvitationNbr}} invitations could not be sent"
    },
    "sendActivityReport": {
      "success": "Your activity report has been sent successfully",
      "failure": "Your activity report could not be sent"
    },
    "uploadDocument": {
      "success": "Your document was successfully uploaded",
      "failure": "Your document could not be uploaded"
    },
    "downloadDocumentContent": {
      "success": "Your document was successfully downloaded",
      "failure": "Your document could not be downloaded"
    },
    "downloadFolderContent": {
      "success": "Your folder was successfully downloaded",
      "failure": "Your folder could not be downloaded"
    },
    "saveTimeRecord": {
      "failure": "Your timesheet could not be edited",
      "timesheetDeadlineExceeded": "The timesheet deadline has been exceeded. You can no longer modify your time entries from the lock date onwards."
    },
    "validateTimeRecordsUpToDate": {
      "failure": "Your timesheet could not be validated"
    },
    "createUnavailability": {
      "success": "Your unavailability has been successfully created.",
      "failure": "Your unavailability could not be created.",
      "emptyName": "You must provide a name.",
      "invalidUnavailabilityDates": "Your unavailability overlaps with another unavailability.",
      "invalidUnavailabilityNonWorkedHoursCount": "The number of hours indicated exceeds the number of hours worked.",
      "invalidDateRange": "The end date cannot be earlier than the start date.",
      "invalidStartDate": "The start date specified is invalid.",
      "invalidResource": "You must specify which member is unavailable.",
      "invalidReason": "You must provide a type of unavailability."
    },
    "createCalendarHolidays": {
      "success": "Your calendar holidays was successfully created",
      "failure": "Your  calendar holidays could not be created"
    },
    "removeCalendarHolidays": {
      "success": "Your calendar holidays was successfully removed",
      "failure": "Your calendar holidays could not be removed"
    },
    "removeHoliday": {
      "success": "Your  holiday was successfully removed",
      "failure": "Your  Holiday could not be removed"
    },
    "useProjectModel": {
      "invalidProjectName": "Your project could not be created from a template, because its name is invalid"
    },
    "duplicateProject": {
      "invalidProjectName": "The project could not be duplicated because the name is invalid"
    }
  },
  "strategicAxesPage": {
    "title": "Strategic axis",
    "navigation": "Strategic axis",
    "createStrategicAxis": "Strategic axe",
    "edit": "Edit",
    "remove": "Remove",
    "table": {
      "strategicProjectAdequacy": "Possibilities of consistency of the project with the strategy",
      "code": "Code",
      "strategicAxis": "Strategic Axe",
      "weight": "Weight"
    },
    "creation": {
      "title": "Create a strategic axe",
      "cancel": "Cancel",
      "submit": "Save",
      "code": "Code",
      "axe": "Axe",
      "weight": "Weight of the objective",
      "strategicProjectAdequacy": "Possibilities of consistency of the project with the strategy",
      "placeholders": {
        "levelOne": "Ex: Highly incoherent",
        "levelTwo": "Ex: Not very coherent",
        "levelThree": "Ex: Neutral",
        "levelFour": "Ex: Coherent",
        "levelFive": "Ex: Strengthens the mission",
        "axeName": "Name the strategic axe",
        "code": "Code"
      }
    },
    "edition": {
      "title": "Create a strategic axe",
      "cancel": "Cancel",
      "submit": "Save",
      "code": "Code",
      "axe": "Axe",
      "weight": "Weight of the objective",
      "strategicProjectAdequacy": "Possibilities of consistency of the project with the strategy",
      "placeholders": {
        "levelOne": "Ex: Highly incoherent",
        "levelTwo": "Ex: Not very coherent",
        "levelThree": "Ex: Neutral",
        "levelFour": "Ex: Coherent",
        "levelFive": "Ex: Strengthens the mission",
        "axeName": "Name the strategic axe",
        "code": "Code"
      }
    },
    "removal": {
      "title": "Are you sure you want to delete this strategic axis ?",
      "confirmation": "The axis will be deleted and removed from the score of all projects.",
      "cancel": "Cancel",
      "confirm": "Confirm"
    }
  },
  "projectStrategicAxes": {
    "title": "Strategical impact",
    "scoring": "Strategical score of the project",
    "coherence": "Coherence with the strategy",
    "score": "Score"
  },
  "moveDocument": {
    "title": "Change directory",
    "placeholder": "Select new folder",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "moveFolder": {
    "title": "Change directory",
    "placeholder": "Select new folder",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "moveOrganizationalUnit": {
    "title": "Move organizational unit",
    "placeholder": "Select the new parent unit",
    "root": "Root (no parent)",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "updateOrganizationalUnit": {
    "title": "Edit « {{- name}} »",
    "name": "Name",
    "resources": "Resources ({{total}})",
    "cancel": "Cancel",
    "confirm": "Save"
  },
  "timesheetPage": {
    "toggle": {
      "personal": "Personal",
      "team": "Team"
    },
    "resourceRemoved": "Removed from project",
    "noAllocation": "Allocation removed"
  },
  "log": {
    "createTask": "{{- author }} created this task",
    "updateTask": "{{- author }} updated this task",
    "deleteTask": "{{- author }} deleted this task",
    "createEvent": "{{- author }} created this event",
    "updateEvent": "{{- author }} updated this event",
    "deleteEvent": "{{- author }} deleted this event",
    "createMilestone": "{{- author }} created this milestone",
    "updateMilestone": "{{- author }} updated this milestone",
    "deleteMilestone": "{{- author }} deleted this milestone",
    "createProject": "{{- author }} created this project",
    "updateProject": "{{- author }} updated this project",
    "deleteProject": "{{- author }} deleted this project",
    "createActivity": "{{- author }} created this list",
    "updateActivity": "{{- author }} updated this list",
    "deleteActivity": "{{- author }} deleted this list"
  },
  "projectLogs": {
    "title": "Project logs",
    "copy": "Copy",
    "log": {
      "createTask": "{{- author }} created the task",
      "updateTask": "{{- author }} updated the task",
      "deleteTask": "{{- author }} deleted the task",
      "createEvent": "{{- author }} created the event",
      "updateEvent": "{{- author }} updated the event",
      "deleteEvent": "{{- author }} deleted the event",
      "createMilestone": "{{- author }} created the milestone",
      "updateMilestone": "{{- author }} updated the milestone",
      "deleteMilestone": "{{- author }} deleted the milestone",
      "createProject": "{{- author }} created the project",
      "updateProject": "{{- author }} updated the project",
      "deleteProject": "{{- author }} deleted the project",
      "createActivity": "{{- author }} created the list",
      "updateActivity": "{{- author }} updated the list",
      "deleteActivity": "{{- author }} deleted the list"
    }
  },
  "notificationsPage": {
    "title": "Notifications",
    "filter": {
      "title": "Filter by type",
      "placeholder": "All types",
      "clear": "Clear filter",
      "selection": {
        "MENTION_IN_COMMENT": "Mentioned in a comment",
        "ADDED_TO_TASK": "Assigned to a task",
        "ADDED_TO_PROJECT": "Assigned to a project",
        "ADDED_TO_EVENT": "Invited to an event",
        "DELAYED_TASK": "Delayed task",
        "EXPORT_BI_FINISHED": "BI export finished"
      }
    }
  },
  "planzoneLogsPage": {
    "title": "Planzone logs",
    "filter": {
      "title": "Filter by :",
      "placeholder": "Select a log type",
      "clear": "Clear filters",
      "selection": {
        "PLANZONE": "Planzone",
        "ZONE": "Zone",
        "PROJECT": "Project",
        "ACTIVITY": "List",
        "TASK": "Task",
        "EVENT": "Event",
        "MILESTONE": "Milestone",
        "RESOURCE": "Resource",
        "UNAVAILABILITY": "Unavailability",
        "COST_PROFILE": "Cost profile",
        "PLANZONE_RESOURCE": "Planzone resources",
        "PROJECT_RESOURCE": "Project resources",
        "PROJECT_RESOURCE_GROUP": "Project resource group",
        "PROJECT_STATUS": "Project statuses",
        "STATUS": "Statuses",
        "STRATEGIC_AXES": "Strategic axes",
        "TIME_RECORD": "Time record",
        "AUTHENTICATION": "Authentication",
        "EMAIL": "Email",
        "NOTIFICATION": "Notifications",
        "PORTFOLIO": "Portfolios"
      }
    },
    "description": {
      "createMilestone": "Created the milestone {{- name }} in project {{- parent }}",
      "createEvent": "Created the event {{- name }} in project {{- parent }}",
      "createTask": "Created the task {{- name }} in project {{- parent }}",
      "createActivity": "Created the list {{- name }} in project {{- parent }}",
      "createProject": "Created the project {{- name }}",
      "createZone": "Created the zone {{- name }}",
      "deleteMilestone": "Deleted the milestone {{- name }} in project {{- parent }}",
      "deleteEvent": "Deleted the event {{- name }} in project {{- parent }}",
      "deleteTask": "Deleted the task {{- name }} in project {{- parent }}",
      "deleteActivity": "Deleted the list {{- name }} in project {{- parent }}",
      "deleteProject": "Deleted the project {{- name }}",
      "deleteZone": "Deleted the zone {{- name }}",
      "createProjectPortfolios": "Created the portfolio {{- name }}",
      "deleteProjectPortfolios": "Deleted the porfolio {{- name }}",
      "updateProjectPortfolios": {
        "name": "Has updated the name of portfolio {{- name }}",
        "color": "Has updated the color of portfolio {{- name }}",
        "description": "Has updated the description of portfolio {{- name }}",
        "project": "Has updated the projects from the portfolio {{- name }}: {{- parent }}",
        "removeProject": "Has removed the following projects from the {{- name }} portfolio: {{- parent }}",
        "addProject": "Has added the following projects to the {{- name }} portfolio: {{- parent }}"
      },
      "updateMilestone": {
        "tags": "Has updated the tags of milestone {{- name }} in project {{- parent }}",
        "name": "Has updated the name of milestone {{- name }} in project {{- parent }}",
        "description": "Has updated the description of milestone {{- name }} in project {{- parent }}",
        "endDate": "Has updated the end date of milestone {{- name }} in project {{- parent }}",
        "move": "Has moved the milestone {{- name }} in project {{- parent }}"
      },
      "updateEvent": {
        "tags": "Has updated the tags of event {{- name }} in project {{- parent }}",
        "addParticipants": "Has added participants to the event {{- name }} in project {{- parent }}",
        "removeParticipants": "Has remove participants to the event {{- name }} in project {{- parent }}",
        "updateParticipants": "Has updated the participants of event {{- name }} in project {{- parent }}",
        "startDate": "Has updated the start date of event {{- name }} in project {{- parent }}",
        "endDate": "Has updated the end date of event {{- name }} in project {{- parent }}",
        "name": "Has updated the name of event {{- name }} in project {{- parent }}",
        "description": "Has updated the description of event {{- name }} in project {{- parent }}",
        "move": "Has moved the event {{- name }} in project {{- parent }}"
      },
      "updateTask": {
        "name": "Has update the title of the task {{- name }} in project {{- parent }}",
        "description": "Has update the description of the task {{- name }} in project {{- parent }}",
        "addAllocation": "Has allocated new resources to the task {{- name }} in project {{- parent }}",
        "deleteAllocation": "Has deallocated resources to the task {{- name }} in project {{- parent }}",
        "tags": "Has update the tags of the task {{- name }} in project {{- parent }}",
        "startDate": "Has update the start date of the task {{- name }} in project {{- parent }}",
        "endDate": "Has update the end date of the task {{- name }} in project {{- parent }}",
        "status": "Has update the status of the task {{- name }} in project {{- parent }}",
        "move": "Has moved the task {{- name }} in project {{- parent }}"
      },
      "updateActivity": {
        "tags": "Has updated the tags of list {{- name }} in project {{- parent }}",
        "name": "Has updated the name of list {{- name }} in project {{- parent }}",
        "description": "Has updated the description of list {{- name }} in project {{- parent }}",
        "startDate": "Has updated the start date of list {{- name }} in project {{- parent }}",
        "endDate": "Has updated the end date of list {{- name }} in project {{- parent }}",
        "move": "Has moved the activity {{- name }} in project {{- parent }}"
      },
      "updateProject": {
        "updateStatus": "Has update a project status {{- name }} for project {{- parent }}",
        "createStatus": "Has created a new project status {{- name }} for project {{- parent }}",
        "deleteStatus": "Has deleted the project status {{- name }} for project {{- parent }}",
        "createProjectResourceGroup": "Has created a new project resource group {{- name }} for project {{- parent }}",
        "updateProjectResourceGroup": "Has updated the project resource group {{- name }} for project {{- parent }}",
        "deleteProjectResourceGroup": "Has deleted the project resource group {{- name }} for project {{- parent }}",
        "enableToolsConfig": "Has enable views for project {{- parent }}",
        "disableToolsConfig": "Has disable views for project {{- parent }}",
        "startDate": "Has updated the start date for project {{- parent }}",
        "endDate": "Has updated the end date for project {{- parent }}",
        "label": "Has updated the label {{- name }} for project {{- parent }}",
        "description": "Has updated the description of project {{- parent }}",
        "name": "Has updated the name of project {{- parent }}",
        "tags": "Has updated the tags for project {{- parent }}",
        "addProjectResourceMaterial": "Has added the material resource {{- name }} to project {{- parent }}",
        "addProjectResourceVirtual": "Has added the virtual resource {{- name }} to project {{- parent }}",
        "addProjectResourceHuman": "Has added the human resource {{- name }} to project {{- parent }}",
        "updateProjectResource": "Has updated resources of project {{- parent }}",
        "removeProjectResource": "Has deleted resources of project {{- parent }}",
        "move": "Has moved the {{- parent }} project to the {{- name }} zone",
        "removeProjectResourceMaterial": "Has removed the material resource {{- name }} to project {{- parent }}",
        "removeProjectResourceVirtual": "Has removed the virtual resource {{- name }} to project {{- parent }}",
        "removeProjectResourceHuman": "Has removed the human resource {{- name }} to project {{- parent }}",
        "activateProjectResourceMaterial": "Has activated the material resource {{- name }} to project {{- parent }}",
        "disableProjectResourceMaterial": "Has disabled the material resource {{- name }} to project {{- parent }}",
        "activateProjectResourceVirtual": "Has activated the virtual resource {{- name }} to project {{- parent }}",
        "disableProjectResourceVirtual": "Has disabled the virtual resource {{- name }} to project {{- parent }}",
        "activateProjectResourceHuman": "Has activated the human resource {{- name }} to project {{- parent }}",
        "disableProjectResourceHuman": "Has disabled the human resource {{- name }} to project {{- parent }}"
      },
      "updateProjectTemplate": {
        "updateStatus": "Has update a project status {{- name }} for project template {{- parent }}",
        "createStatus": "Has created a new project status {{- name }} for project template {{- parent }}",
        "deleteStatus": "Has deleted the project status {{- name }} for project template {{- parent }}",
        "createProjectResourceGroup": "Has created a new project resource group {{- name }} for project template {{- parent }}",
        "updateProjectResourceGroup": "Has updated the project resource group {{- name }} for project template {{- parent }}",
        "deleteProjectResourceGroup": "Has deleted the project resource group {{- name }} for project template {{- parent }}",
        "enableToolsConfig": "Has enable views for project template {{- parent }}",
        "disableToolsConfig": "Has disable views for project template {{- parent }}",
        "startDate": "Has updated the start date for project template {{- parent }}",
        "endDate": "Has updated the end date for project template {{- parent }}",
        "label": "Has updated the label {{- name }} for project template {{- parent }}",
        "description": "Has updated the description of project template {{- parent }}",
        "name": "Has updated the name of project template {{- parent }}",
        "tags": "Has updated the tags for project template {{- parent }}",
        "addProjectResource": "Has added new resources to project template {{- parent }}",
        "updateProjectResource": "Has updated resources of project template {{- parent }}",
        "removeProjectResource": "Has deleted resources of project template {{- parent }}"
      },
      "updateZone": {
        "name": "Has updated the name of the zone {{- name }}",
        "description": "Has updated the description of the zone {{- name }}"
      },
      "createProjectStatus": "Has created the project status {{- name }}",
      "deleteProjectStatus": "Has deleted the project status {{- name }}",
      "updateProjectStatus": {
        "label": "Has updated the name of project status {{- name }}",
        "description": "Has updated the description of project status {{- name }}",
        "color": "Has updated the color of project status {{- name }}"
      },
      "createProjectTemplate": "Has created the project template {{- name }}",
      "deleteProjectTemplate": "Has deleted the project template {{- name }}",
      "createUnavailability": "Has created a new unavailability {{- name }}",
      "deleteUnavailability": "Has deleted a new unavailability {{- name }}",
      "updateUnavailability": {
        "reason": "Has updated the type of the unavailability {{- name }}",
        "name": "Has updated the name of the unavailability {{- name }}",
        "resource": "Has updated the resource of the unavailability {{- name }}",
        "startDate": "Has updated the start date of the unavailability {{- name }}",
        "endDate": "Has updated the end date of the unavailability {{- name }}",
        "nonWorkedHours": "Has updated the number of non worked hours of the unavailability {{- name }}"
      },
      "updatePlanzone": {
        "projectPortfolios": "Has updated the portfolios of the planzone",
        "projectReportTemplate": "Has updated the project report templates of the planzone",
        "createProjectReportTemplate": "Has created the project report template {{- name }}",
        "deleteProjectReportTemplate": "Has deleted the project report template {{- name }}",
        "updateProjectReportTemplate": "Has updated the project report template {{- name }}",
        "createProjectPortfolios": "Has created the portfolio {{- name }}",
        "deleteProjectPortfolios": "Has deleted the portfolio {{- name }}",
        "updateProjectPortfoliosColor": "Has updated the color of the portfolio {{- name }}",
        "updateProjectPortfoliosDescription": "Has updated the description of the portfolio {{- name }}",
        "updateProjectPortfoliosProject": "Has updated the projects of the portfolio {{- name }}",
        "updateProjectPortfoliosName": "Has updated the name of the portfolio {{- name }}",
        "updateProjectPortfolios": "Has updated the portfolio {{- name }}"
      },
      "createCostProfile": "Has created the cost profile {{- name }}",
      "deleteCostProfile": "Has deleted the cost profile {{- name }}",
      "updateCostProfile": {
        "name": "Has updated the name of cost profile {{- name }}",
        "description": "Has updated the description of cost profile {{- name }}",
        "cost": "Has updated the history of cost profile {{- name }}"
      },
      "createGroupPlanzone": "Has created a new resource group {{- name }}",
      "deleteGroupPlanzone": "Has deleted the resource group {{- name }}",
      "updateGroupPlanzone": {
        "name": "Has updated the name of the resource group {{- name }}",
        "description": "Has updated the description of the resource group {{- name }}",
        "addResources": "Has added resources to the resource group {{- name }}",
        "removeResources": "Has remove resources to the resource group {{- name }}"
      },
      "createPlanzoneHumanResource": "Has created the new human resource {{- name }}",
      "createPlanzoneVirtualResource": "Has created the new virtual resource {{- name }}",
      "createPlanzoneMaterialResource": "as created the new material resource {{- name }}",
      "deletePlanzoneHumanResource": "Has deleted the human resource {{- name }}",
      "deletePlanzoneVirtualResource": "Has deleted the virtual resource {{- name }}",
      "deletePlanzoneMaterialResource": "Has deleted the material resource {{- name }}",
      "updatePlanzoneHumanResource": {
        "name": "Has updated the name of the human resource {{- name }}",
        "description": "Has updated the description of the human resource {{- name }}",
        "profession": "Has updated the profession of the human resource {{- name }}",
        "tags": "Has updated the tags of the human resource {{- name }}",
        "personalWeeklyCalendar": "Has updated it personal calendar",
        "weeklyCalendar": "Has updated the personal calendar of the resource {{- name }}",
        "affiliation": "Has updated {{- name }} dependent resources"
      },
      "updatePlanzoneVirtualResource": {
        "name": "Has updated the name of the virtual resource {{- name }}",
        "description": "Has updated the description of the virtual resource {{- name }}",
        "profession": "Has updated the profession of the virtual resource {{- name }}",
        "tags": "Has updated the tags of the virtual resource {{- name }}",
        "personalWeeklyCalendar": "Has updated it personal calendar",
        "weeklyCalendar": "Has updated the personal calendar of the resource {{- name }}",
        "affiliation": "Has updated {{- name }} dependent resources"
      },
      "updatePlanzoneMaterialResource": {
        "name": "Has updated the name of the material resource {{- name }}",
        "description": "Has updated the description of the material resource {{- name }}",
        "profession": "Has updated the profession of the material resource {{- name }}",
        "tags": "Has updated the tags of the material resource {{- name }}",
        "personalWeeklyCalendar": "Has updated it personal calendar",
        "weeklyCalendar": "Has updated the personal calendar of the resource {{- name }}",
        "affiliation": "Has updated {{- name }} dependent resources"
      },
      "updateTimeRecord": {
        "personal": "Has updated it allocated hours",
        "group": "Has updated {{- name }} allocated hours"
      },
      "createStrategicAxes": "Has created the strategic axe {{- name }}",
      "deleteStrategicAxes": "as deleted the strategic axe {{- name }}",
      "updateStrategicAxes": {
        "color": "Has updated the color of strategic axe {{- name }}",
        "name": "Has updated the name of strategic axe {{- name }}",
        "code": "Has updated the code of strategic axe {{- name }}",
        "weight": "Has updated the weight of strategic axe {{- name }}"
      },
      "emailSender": {
        "mentionUserInComment": "An email has been sent to {{- name }} after he was mentioned in a comment",
        "taskAllocation": "An email has been sent to {{- name }} after he had time allocated to a task",
        "projectMember": "An email has been sent to {{- name }} after he was added to a project",
        "userAddedToTask": "An email has been sent to {{- name }} after he was added to a task",
        "userAddedToProject": "An email has been sent to {{- name }} after he was added to a project",
        "delayedTask": "An email has been sent to {{- name }} for his delayed tasks",
        "reportActivity": "An email has been sent to {{- name }} for his report",
        "joinPlanzoneInvitation": "An email has been sent to {{- name }} to invite him to join a planzone",
        "planzoneNumberOfProjectsReached": "An email has been sent to {{- name }} after he reached the number of projects in his planzone",
        "userAddedToPlanzoneNotification": "An email has been sent to {{- name }} after he was added to a planzone",
        "userRemovedFromTask": "An email has been sent to {{- name }} after he was removed from a task",
        "userRemovedFromProject": "An email has been sent to {{- name }} after he was removed from a project",
        "userAddedToEvent": "An email has been sent to {{- name }} after he was added to an event",
        "licenseExpired": "An email has been sent to {{- name }} after his license expired",
        "activityReport": "An email has been sent to {{- name }} for his activity report",
        "failure": {
          "mentionUserInComment": "Failure to send email to {{- name }} after he was mentioned in a comment",
          "taskAllocation": "Failure to send email to {{- name }} after he had time allocated to a task",
          "projectMember": "Failure to send email to {{- name }} after he was added to a project",
          "userAddedToTask": "Failure to send email to {{- name }} after he was added to a task",
          "userAddedToProject": "Failure to send email to {{- name }} after he was added to a project",
          "delayedTask": "Failure to send email to {{- name }} for his delayed tasks",
          "reportActivity": "Failure to send email to {{- name }} for his report",
          "joinPlanzoneInvitation": "Failure to send email to {{- name }} to invite him to join a planzone",
          "planzoneNumberOfProjectsReached": "Failure to send email to {{- name }} after he reached the number of projects in his planzone",
          "userAddedToPlanzoneNotification": "Failure to send email to {{- name }} after he was added to a planzone",
          "userRemovedFromTask": "Failure to send email to {{- name }} after he was removed from a task",
          "userRemovedFromProject": "Failure to send email to {{- name }} after he was removed from a project",
          "userAddedToEvent": "Failure to send email to {{- name }} after he was added to an event",
          "licenseExpired": "Failure to send email to {{- name }} after his license expired",
          "activityReport": "Failure to send email to {{- name }} for his activity report"
        }
      },
      "authentication": {
        "usernamePassword": "Just connected using his username and password",
        "sso": "Just connected using SSO"
      }
    }
  },
  "documentCreation": {
    "title": "Document creation",
    "submit": "Submit",
    "cancel": "Cancel",
    "name": {
      "title": "Name the document",
      "placeholder": "Give your document a name"
    },
    "templates": {
      "title": "Template for the document",
      "emptyDocument": "Empty"
    },
    "folderSelection": {
      "title": "Select a folder"
    }
  },
  "documentEdition": {
    "close": "Close"
  },
  "folderUpdate": {
    "title": "Rename folder",
    "placeholder": "Give your folder a new name",
    "cancel": "Cancel",
    "submit": "Rename"
  },
  "documentUpdate": {
    "title": "Rename document",
    "placeholder": "Give your document a new name",
    "cancel": "Cancel",
    "submit": "Rename"
  },
  "taskPopup": {
    "edit": "Edit",
    "delete": "Delete",
    "project": "Part of"
  },
  "eventPopup": {
    "edit": "Edit",
    "delete": "Delete",
    "project": "Part of"
  },
  "assignToTask": {
    "title": "Assign to an existing task",
    "resourceLabel": "Resource",
    "resourcePlaceholder": "Select a resource",
    "projectLabel": "Project name",
    "projectPlaceholder": "Select a project",
    "taskLabel": "Task name",
    "taskPlaceholder": "Select a task",
    "confirm": "Assign"
  },
  "richTextInput": {
    "link": {
      "title": "Insert a link",
      "placeholder": "https://...",
      "remove": "Remove link"
    },
    "image": {
      "title": "Insert an image",
      "placeholder": "https://..."
    },
    "youtube": {
      "title": "Insert a YouTube video",
      "placeholder": "https://www.youtube.com/watch?v=..."
    },
    "confirm": "OK",
    "cancel": "Cancel",
    "toolbar": {
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strikethrough": "Strikethrough",
      "alignLeft": "Align left",
      "alignCenter": "Center",
      "alignRight": "Align right",
      "bulletList": "Bullet list",
      "orderedList": "Numbered list",
      "taskList": "Checkboxes",
      "textColor": "Text color",
      "highlight": "Highlight",
      "codeBlock": "Code block",
      "blockquote": "Blockquote",
      "table": "Table",
      "image": "Image",
      "link": "Link",
      "youtube": "YouTube video",
      "addColumnBefore": "Add column before",
      "addColumnAfter": "Add column after",
      "deleteColumn": "Delete column",
      "addRowBefore": "Add row before",
      "addRowAfter": "Add row after",
      "deleteRow": "Delete row",
      "deleteTable": "Delete table"
    }
  },
  "allocationWarnings": {
    "title": "Warning",
    "intro": "Attention, the following resource(s) do not comply with one of the scheduling rules:",
    "hasDailyAmplitudeWarning": "Maximum daily work amplitude ({{threshold}}h) exceeded on",
    "hasDailyVolumeWarning": "Maximum daily work volume ({{threshold}}h) exceeded on",
    "hasRestPeriodWarning": "Minimum recommended rest period ({{threshold}}h) exceeded between this task and the next on",
    "hasUnavailabilityWarning": "You are about to assign <bold>{{resourceName}}</bold> to a task whose duration overlaps one of their unavailabilities: <bold>{{unavailabilityLabel}}</bold> (<bold>{{unavailabilityDurationHours}}h</bold>)",
    "confirm": "Continue",
    "cancel": "Cancel"
  },
  "obsPage": {
    "filters": {
      "title": "Filter by :",
      "default": "No filter",
      "resourceStatuses": {
        "label": "Show resources:",
        "placeholder": "All resources",
        "activated": "Activated",
        "deactivated": "Deactivated"
      }
    },
    "title": "Org chart",
    "createRootUnit": "Organizational unit",
    "addSubUnit": "+ Add",
    "rename": "Rename",
    "remove": "Delete",
    "move": "Move",
    "edit": "Edit",
    "creation": {
      "title": "Create an organizational unit",
      "name": "Name",
      "namePlaceholder": "Unit name",
      "parent": "Parent unit",
      "root": "Root (no parent)",
      "resources": "Resources ({{total}})",
      "cancel": "Cancel",
      "submit": "Save"
    },
    "removal": {
      "title": "Are you sure you want to delete this organizational unit ?",
      "confirmation": "« {{- name}} » and all its sub-units will be permanently deleted. Attached resources will not be deleted but will no longer belong to a unit. This action cannot be undone.",
      "cancel": "Cancel",
      "confirm": "Confirm"
    }
  }
}
